var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _g, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _g2, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _g3, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _g4, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _g5, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _g6, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _g7, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _g8, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _g9, _path841, _path842, _g0, _path843, _path844, _path845, _path846, _path847, _g1, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _g10, _path855, _path856, _path857, _path858, _path859, _g11, _path860, _path861, _path862, _g12, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _g13, _path873, _path874, _path875, _path876, _g14, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _g15, _path884, _g16, _path885, _path886, _path887, _path888, _path889, _g17, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _g18, _path900, _path901, _path902, _g19, _path903, _path904, _path905, _path906, _g20, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoBrand({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 601,
    height: 400,
    viewBox: "0 0 601 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M303.345 266.681V375.386H545.924V314.873H524.88V340.432H519.462V325.965H492.703V348.876H489.162V258.446H465.905V309.863H453.978V328.228H450.367V316.679H429.223V351.137H423.042V323.129H403.705V301.846H390.558V289.732H375.348V343.478H370.228V284.381H345.175V316.489H341.713V290.285H316.303V266.681H303.345Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M539.785 322.975H543.346V318.088H539.785V322.975Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M533.613 322.975H537.174V318.088H533.613V322.975Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M527.441 322.975H531.002V318.088H527.441V322.975Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M539.785 330.327H543.346V325.441H539.785V330.327Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M533.613 330.327H537.174V325.441H533.613V330.327Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M527.441 330.327H531.002V325.441H527.441V330.327Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M539.785 337.679H543.346V332.792H539.785V337.679Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M533.613 337.679H537.174V332.792H533.613V337.679Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M527.441 337.679H531.002V332.792H527.441V337.679Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M539.785 345.031H543.346V340.144H539.785V345.031Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M533.613 345.031H537.174V340.144H533.613V345.031Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M527.441 345.031H531.002V340.144H527.441V345.031Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M416.51 330.693H420.071V326.617H416.51V330.693Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M410.339 330.693H413.899V326.617H410.339V330.693Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M404.168 330.693H407.729V326.617H404.168V330.693Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M416.51 336.827H420.071V332.751H416.51V336.827Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M410.339 336.827H413.899V332.751H410.339V336.827Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M404.168 336.827H407.729V332.751H404.168V336.827Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M416.51 342.96H420.071V338.884H416.51V342.96Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M410.339 342.96H413.899V338.884H410.339V342.96Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M404.168 342.96H407.729V338.884H404.168V342.96Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M416.51 349.094H420.071V345.017H416.51V349.094Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M410.339 349.094H413.899V345.017H410.339V349.094Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M404.168 349.094H407.729V345.017H404.168V349.094Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M416.51 355.379H420.071V351.302H416.51V355.379Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M410.339 355.379H413.899V351.302H410.339V355.379Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M404.168 355.379H407.729V351.302H404.168V355.379Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M416.51 361.665H420.071V357.588H416.51V361.665Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M410.339 361.665H413.899V357.588H410.339V361.665Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M404.168 361.665H407.729V357.588H404.168V361.665Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M416.51 367.95H420.071V363.874H416.51V367.95Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M410.339 367.95H413.899V363.874H410.339V367.95Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M404.168 367.95H407.729V363.874H404.168V367.95Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M495.926 332.153H516.425V329.097H495.926V332.153Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M495.926 338.082H516.425V335.026H495.926V338.082Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M495.926 344.012H516.425V340.956H495.926V344.012Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M495.926 349.941H516.425V346.885H495.926V349.941Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M495.926 355.87H516.425V352.814H495.926V355.87Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M495.926 361.8H516.425V358.744H495.926V361.8Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M495.926 367.729H516.425V364.673H495.926V367.729Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M495.926 373.659H516.425V370.603H495.926V373.659Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M348.357 290.29H367.202V287.234H348.357V290.29Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M348.357 296.22H367.202V293.164H348.357V296.22Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M348.357 302.149H367.202V299.093H348.357V302.149Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M348.357 308.079H367.202V305.023H348.357V308.079Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M367.202 310.953H348.356V314.009H367.202V310.953Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M348.357 319.938H367.202V316.882H348.357V319.938Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M348.357 325.867H367.202V322.811H348.357V325.867Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M348.357 331.797H367.202V328.741H348.357V331.797Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M348.357 337.43H367.202V334.374H348.357V337.43Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M348.357 343.065H367.202V340.009H348.357V343.065Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M348.357 348.699H367.202V345.643H348.357V348.699Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M348.357 354.333H367.202V351.277H348.357V354.333Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M317.886 297.453H337.793V294.397H317.886V297.453Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M317.886 303.382H337.793V300.326H317.886V303.382Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M317.886 309.312H337.793V306.256H317.886V309.312Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M317.886 315.241H337.793V312.185H317.886V315.241Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M317.886 321.171H337.793V318.115H317.886V321.171Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M317.886 327.1H337.793V324.044H317.886V327.1Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M317.886 333.029H337.793V329.973H317.886V333.029Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M317.886 338.958H337.793V335.902H317.886V338.958Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M317.886 344.266H337.793V341.21H317.886V344.266Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M317.886 349.573H337.793V346.517H317.886V349.573Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M317.886 354.88H337.793V351.824H317.886V354.88Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M437.855 322.398H444.185V319.447H437.855V322.398Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M437.855 328.124H444.185V325.173H437.855V328.124Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M437.855 333.85H444.185V330.898H437.855V333.85Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M437.855 339.577H444.185V336.625H437.855V339.577Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M437.855 345.302H444.185V342.351H437.855V345.302Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M437.855 351.028H444.185V348.077H437.855V351.028Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M437.855 356.754H444.185V353.803H437.855V356.754Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M437.855 362.48H444.185V359.529H437.855V362.48Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M429.241 322.398H435.57V319.447H429.241V322.398Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M429.241 328.124H435.57V325.173H429.241V328.124Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M429.241 333.85H435.57V330.898H429.241V333.85Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M429.241 339.577H435.57V336.625H429.241V339.577Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M429.241 345.302H435.57V342.351H429.241V345.302Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M429.241 351.028H435.57V348.077H429.241V351.028Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M429.241 356.754H435.57V353.803H429.241V356.754Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M429.241 362.48H435.57V359.529H429.241V362.48Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M479.039 266.194H485.634V261.54H479.039V266.194Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M469.208 266.194H475.803V261.54H469.208V266.194Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M479.039 273.03H485.634V268.376H479.039V273.03Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M469.208 273.03H475.803V268.376H469.208V273.03Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M479.039 279.867H485.634V275.213H479.039V279.867Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M469.208 279.867H475.803V275.213H469.208V279.867Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M479.039 286.703H485.634V282.05H479.039V286.703Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M469.208 286.703H475.803V282.05H469.208V286.703Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M479.039 293.541H485.634V288.887H479.039V293.541Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M469.208 293.541H475.803V288.887H469.208V293.541Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M479.039 300.377H485.634V295.724H479.039V300.377Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M469.208 300.377H475.803V295.724H469.208V300.377Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M479.039 307.213H485.634V302.56H479.039V307.213Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M469.208 307.213H475.803V302.56H469.208V307.213Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M479.039 314.05H485.634V309.396H479.039V314.05Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M469.208 314.05H475.803V309.396H469.208V314.05Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M457.021 316.53H463.616V311.875H457.021V316.53Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M457.021 323.366H463.616V318.713H457.021V323.366Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M457.021 330.203H463.616V325.55H457.021V330.203Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M457.021 337.041H463.616V332.387H457.021V337.041Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M457.021 343.877H463.616V339.223H457.021V343.877Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M457.021 350.713H463.616V346.059H457.021V350.713Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M479.039 320.805H485.634V316.151H479.039V320.805Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M469.208 320.805H475.803V316.151H469.208V320.805Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M457.021 357.468H463.616V352.815H457.021V357.468Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M479.039 327.561H485.634V322.906H479.039V327.561Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M469.208 327.561H475.803V322.906H469.208V327.561Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M457.021 364.224H463.616V359.569H457.021V364.224Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M479.039 334.316H485.634V329.662H479.039V334.316Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M469.208 334.316H475.803V329.662H469.208V334.316Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M457.021 370.979H463.616V366.325H457.021V370.979Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M479.039 341.071H485.634V336.417H479.039V341.071Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M469.208 341.071H475.803V336.417H469.208V341.071Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M479.039 347.826H485.634V343.173H479.039V347.826Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M469.208 347.826H475.803V343.173H469.208V347.826Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M397.458 308.922H401.019V304.846H397.458V308.922Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M391.286 308.922H394.847V304.846H391.286V308.922Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M397.458 315.056H401.019V310.979H397.458V315.056Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M391.286 315.056H394.847V310.979H391.286V315.056Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M397.458 321.189H401.019V317.113H397.458V321.189Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M391.286 321.189H394.847V317.113H391.286V321.189Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M397.458 327.323H401.019V323.246H397.458V327.323Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M391.286 327.323H394.847V323.246H391.286V327.323Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M397.458 333.608H401.019V329.531H397.458V333.608Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M391.286 333.608H394.847V329.531H391.286V333.608Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M397.458 339.893H401.019V335.817H397.458V339.893Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M391.286 339.893H394.847V335.817H391.286V339.893Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M397.458 346.179H401.019V342.102H397.458V346.179Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M391.286 346.179H394.847V342.102H391.286V346.179Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M397.458 352.465H401.019V348.388H397.458V352.465Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M391.286 352.465H394.847V348.388H391.286V352.465Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M397.458 358.817H401.019V354.74H397.458V358.817Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M391.286 358.817H394.847V354.74H391.286V358.817Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M397.458 365.168H401.019V361.092H397.458V365.168Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M391.286 365.168H394.847V361.092H391.286V365.168Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M397.458 371.521H401.019V367.445H397.458V371.521Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M391.286 371.521H394.847V367.445H391.286V371.521Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M310.51 273.647H314.071V268.845H310.51V273.647Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M304.34 273.647H307.9V268.845H304.34V273.647Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M310.51 280.874H314.071V276.071H310.51V280.874Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M304.34 280.874H307.9V276.071H304.34V280.874Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M310.51 288.099H314.071V283.297H310.51V288.099Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M304.34 288.099H307.9V283.297H304.34V288.099Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M310.51 295.326H314.071V290.523H310.51V295.326Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M304.34 295.326H307.9V290.523H304.34V295.326Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M310.51 302.731H314.071V297.928H310.51V302.731Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M304.34 302.731H307.9V297.928H304.34V302.731Z",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M310.51 310.135H314.071V305.333H310.51V310.135Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M304.34 310.135H307.9V305.333H304.34V310.135Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M310.51 317.54H314.071V312.738H310.51V317.54Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M304.34 317.54H307.9V312.738H304.34V317.54Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M310.51 324.945H314.071V320.143H310.51V324.945Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M304.34 324.945H307.9V320.143H304.34V324.945Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M310.51 332.429H314.071V327.627H310.51V332.429Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M304.34 332.429H307.9V327.627H304.34V332.429Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M310.51 339.912H314.071V335.11H310.51V339.912Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M304.34 339.912H307.9V335.11H304.34V339.912Z",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M310.51 347.396H314.071V342.594H310.51V347.396Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M304.34 347.396H307.9V342.594H304.34V347.396Z",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M310.51 354.879H314.071V350.077H310.51V354.879Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M304.34 354.879H307.9V350.077H304.34V354.879Z",
    fill: "white"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M384.26 308.922H387.82V304.846H384.26V308.922Z",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M378.089 308.922H381.649V304.846H378.089V308.922Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M384.26 302.634H387.82V298.558H384.26V302.634Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M378.089 302.634H381.649V298.558H378.089V302.634Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M384.26 296.344H387.82V292.267H384.26V296.344Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M378.089 296.344H381.649V292.267H378.089V296.344Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M384.26 315.056H387.82V310.979H384.26V315.056Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M378.089 315.056H381.649V310.979H378.089V315.056Z",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M384.26 321.189H387.82V317.113H384.26V321.189Z",
    fill: "white"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M378.089 321.189H381.649V317.113H378.089V321.189Z",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M384.26 327.323H387.82V323.246H384.26V327.323Z",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M378.089 327.323H381.649V323.246H378.089V327.323Z",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M384.26 333.608H387.82V329.531H384.26V333.608Z",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M378.089 333.608H381.649V329.531H378.089V333.608Z",
    fill: "white"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M384.26 339.893H387.82V335.817H384.26V339.893Z",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M378.089 339.893H381.649V335.817H378.089V339.893Z",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M384.26 346.179H387.82V342.102H384.26V346.179Z",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M378.089 346.179H381.649V342.102H378.089V346.179Z",
    fill: "white"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M384.26 352.465H387.82V348.388H384.26V352.465Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M378.089 352.465H381.649V348.388H378.089V352.465Z",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M384.26 358.817H387.82V354.74H384.26V358.817Z",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M378.089 358.817H381.649V354.74H378.089V358.817Z",
    fill: "white"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M384.26 365.168H387.82V361.092H384.26V365.168Z",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M378.089 365.168H381.649V361.092H378.089V365.168Z",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M384.26 371.521H387.82V367.445H384.26V371.521Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M378.089 371.521H381.649V367.445H378.089V371.521Z",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0771 330.878V375.386H303.344V314.873H282.3V340.432H276.883V325.965H250.124V348.876H246.582V258.446H223.325V309.863H211.399V328.228H207.788V316.679H186.644V351.137H180.463V323.129H161.125V301.846H147.979V289.732H132.768V343.478H127.648V284.381H102.596V316.489H99.1331V290.285H71.3595V330.878H55.0771Z",
    fill: "#EBEBEB"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M297.204 322.975H300.765V318.088H297.204V322.975Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M291.033 322.975H294.594V318.088H291.033V322.975Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M284.861 322.975H288.422V318.088H284.861V322.975Z",
    fill: "white"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M297.204 330.327H300.765V325.441H297.204V330.327Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M291.033 330.327H294.594V325.441H291.033V330.327Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M284.861 330.327H288.422V325.441H284.861V330.327Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M297.204 337.679H300.765V332.792H297.204V337.679Z",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M291.033 337.679H294.594V332.792H291.033V337.679Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M284.861 337.679H288.422V332.792H284.861V337.679Z",
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M297.204 345.031H300.765V340.144H297.204V345.031Z",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M291.033 345.031H294.594V340.144H291.033V345.031Z",
    fill: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M284.861 345.031H288.422V340.144H284.861V345.031Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M173.93 330.693H177.491V326.617H173.93V330.693Z",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M167.759 330.693H171.319V326.617H167.759V330.693Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M161.588 330.693H165.148V326.617H161.588V330.693Z",
    fill: "white"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M173.93 336.827H177.491V332.751H173.93V336.827Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M167.759 336.827H171.319V332.751H167.759V336.827Z",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M161.588 336.827H165.148V332.751H161.588V336.827Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M173.93 342.96H177.491V338.884H173.93V342.96Z",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M167.759 342.96H171.319V338.884H167.759V342.96Z",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M161.588 342.96H165.148V338.884H161.588V342.96Z",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M173.93 349.094H177.491V345.017H173.93V349.094Z",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M167.759 349.094H171.319V345.017H167.759V349.094Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M161.588 349.094H165.148V345.017H161.588V349.094Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M173.93 355.379H177.491V351.302H173.93V355.379Z",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M167.759 355.379H171.319V351.302H167.759V355.379Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M161.588 355.379H165.148V351.302H161.588V355.379Z",
    fill: "white"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M173.93 361.665H177.491V357.588H173.93V361.665Z",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M167.759 361.665H171.319V357.588H167.759V361.665Z",
    fill: "white"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M161.588 361.665H165.148V357.588H161.588V361.665Z",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M173.93 367.95H177.491V363.874H173.93V367.95Z",
    fill: "white"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M167.759 367.95H171.319V363.874H167.759V367.95Z",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M161.588 367.95H165.148V363.874H161.588V367.95Z",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M253.346 332.153H273.845V329.097H253.346V332.153Z",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M253.346 338.082H273.845V335.026H253.346V338.082Z",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M253.346 344.012H273.845V340.956H253.346V344.012Z",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M253.346 349.941H273.845V346.885H253.346V349.941Z",
    fill: "white"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M253.346 355.87H273.845V352.814H253.346V355.87Z",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M253.346 361.8H273.845V358.744H253.346V361.8Z",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M253.346 367.729H273.845V364.673H253.346V367.729Z",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M105.776 290.29H124.622V287.234H105.776V290.29Z",
    fill: "white"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M105.776 296.22H124.622V293.164H105.776V296.22Z",
    fill: "white"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M105.776 302.149H124.622V299.093H105.776V302.149Z",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M105.776 308.079H124.622V305.023H105.776V308.079Z",
    fill: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M124.622 310.953H105.776V314.009H124.622V310.953Z",
    fill: "white"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M105.776 319.938H124.622V316.882H105.776V319.938Z",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M105.776 325.867H124.622V322.811H105.776V325.867Z",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M105.776 331.797H124.622V328.741H105.776V331.797Z",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M105.776 337.43H124.622V334.374H105.776V337.43Z",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M105.776 343.065H124.622V340.009H105.776V343.065Z",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M105.776 348.699H124.622V345.643H105.776V348.699Z",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M105.776 354.333H124.622V351.277H105.776V354.333Z",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3057 297.453H95.2129V294.397H75.3057V297.453Z",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3057 303.382H95.2129V300.326H75.3057V303.382Z",
    fill: "white"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3057 309.312H95.2129V306.256H75.3057V309.312Z",
    fill: "white"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3057 315.241H95.2129V312.185H75.3057V315.241Z",
    fill: "white"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3057 321.171H95.2129V318.115H75.3057V321.171Z",
    fill: "white"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3057 327.1H95.2129V324.044H75.3057V327.1Z",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3057 333.029H95.2129V329.973H75.3057V333.029Z",
    fill: "white"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3057 338.958H95.2129V335.902H75.3057V338.958Z",
    fill: "white"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3057 344.266H95.2129V341.21H75.3057V344.266Z",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3057 349.573H95.2129V346.517H75.3057V349.573Z",
    fill: "white"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3057 354.88H95.2129V351.824H75.3057V354.88Z",
    fill: "white"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M195.274 322.398H201.604V319.447H195.274V322.398Z",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M195.274 328.124H201.604V325.173H195.274V328.124Z",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M195.274 333.85H201.604V330.898H195.274V333.85Z",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M195.274 339.577H201.604V336.625H195.274V339.577Z",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M195.274 345.302H201.604V342.351H195.274V345.302Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M195.274 351.028H201.604V348.077H195.274V351.028Z",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M195.274 356.754H201.604V353.803H195.274V356.754Z",
    fill: "white"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M195.274 362.48H201.604V359.529H195.274V362.48Z",
    fill: "white"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M186.661 322.398H192.99V319.447H186.661V322.398Z",
    fill: "white"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M186.661 328.124H192.99V325.173H186.661V328.124Z",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M186.661 333.85H192.99V330.898H186.661V333.85Z",
    fill: "white"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M186.661 339.577H192.99V336.625H186.661V339.577Z",
    fill: "white"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M186.661 345.302H192.99V342.351H186.661V345.302Z",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M186.661 351.028H192.99V348.077H186.661V351.028Z",
    fill: "white"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M186.661 356.754H192.99V353.803H186.661V356.754Z",
    fill: "white"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M186.661 362.48H192.99V359.529H186.661V362.48Z",
    fill: "white"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M236.459 266.194H243.054V261.54H236.459V266.194Z",
    fill: "white"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M226.628 266.194H233.223V261.54H226.628V266.194Z",
    fill: "white"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M236.459 273.03H243.054V268.376H236.459V273.03Z",
    fill: "white"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M226.628 273.03H233.223V268.376H226.628V273.03Z",
    fill: "white"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M236.459 279.867H243.054V275.213H236.459V279.867Z",
    fill: "white"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M226.628 279.867H233.223V275.213H226.628V279.867Z",
    fill: "white"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M236.459 286.703H243.054V282.05H236.459V286.703Z",
    fill: "white"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M226.628 286.703H233.223V282.05H226.628V286.703Z",
    fill: "white"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M236.459 293.541H243.054V288.887H236.459V293.541Z",
    fill: "white"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M226.628 293.541H233.223V288.887H226.628V293.541Z",
    fill: "white"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M236.459 300.377H243.054V295.724H236.459V300.377Z",
    fill: "white"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M226.628 300.377H233.223V295.724H226.628V300.377Z",
    fill: "white"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M236.459 307.213H243.054V302.56H236.459V307.213Z",
    fill: "white"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M226.628 307.213H233.223V302.56H226.628V307.213Z",
    fill: "white"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M236.459 314.05H243.054V309.396H236.459V314.05Z",
    fill: "white"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M226.628 314.05H233.223V309.396H226.628V314.05Z",
    fill: "white"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M214.442 316.53H221.037V311.875H214.442V316.53Z",
    fill: "white"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M214.442 323.366H221.037V318.713H214.442V323.366Z",
    fill: "white"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M214.442 330.203H221.037V325.55H214.442V330.203Z",
    fill: "white"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M214.442 337.041H221.037V332.387H214.442V337.041Z",
    fill: "white"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M214.442 343.877H221.037V339.223H214.442V343.877Z",
    fill: "white"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M214.442 350.713H221.037V346.059H214.442V350.713Z",
    fill: "white"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M236.459 320.805H243.054V316.151H236.459V320.805Z",
    fill: "white"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M226.628 320.805H233.223V316.151H226.628V320.805Z",
    fill: "white"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M214.442 357.468H221.037V352.815H214.442V357.468Z",
    fill: "white"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M236.459 327.561H243.054V322.906H236.459V327.561Z",
    fill: "white"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M226.628 327.561H233.223V322.906H226.628V327.561Z",
    fill: "white"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M214.442 364.224H221.037V359.569H214.442V364.224Z",
    fill: "white"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M236.459 334.316H243.054V329.662H236.459V334.316Z",
    fill: "white"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M226.628 334.316H233.223V329.662H226.628V334.316Z",
    fill: "white"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M214.442 370.979H221.037V366.325H214.442V370.979Z",
    fill: "white"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M236.459 341.071H243.054V336.417H236.459V341.071Z",
    fill: "white"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M226.628 341.071H233.223V336.417H226.628V341.071Z",
    fill: "white"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M236.459 347.826H243.054V343.173H236.459V347.826Z",
    fill: "white"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M226.628 347.826H233.223V343.173H226.628V347.826Z",
    fill: "white"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M154.877 308.922H158.438V304.846H154.877V308.922Z",
    fill: "white"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M148.706 308.922H152.267V304.846H148.706V308.922Z",
    fill: "white"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M154.877 315.056H158.438V310.979H154.877V315.056Z",
    fill: "white"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M148.706 315.056H152.267V310.979H148.706V315.056Z",
    fill: "white"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M154.877 321.189H158.438V317.113H154.877V321.189Z",
    fill: "white"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M148.706 321.189H152.267V317.113H148.706V321.189Z",
    fill: "white"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M154.877 327.323H158.438V323.246H154.877V327.323Z",
    fill: "white"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M148.706 327.323H152.267V323.246H148.706V327.323Z",
    fill: "white"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M154.877 333.608H158.438V329.531H154.877V333.608Z",
    fill: "white"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M148.706 333.608H152.267V329.531H148.706V333.608Z",
    fill: "white"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M154.877 339.893H158.438V335.817H154.877V339.893Z",
    fill: "white"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M148.706 339.893H152.267V335.817H148.706V339.893Z",
    fill: "white"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M154.877 346.179H158.438V342.102H154.877V346.179Z",
    fill: "white"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M148.706 346.179H152.267V342.102H148.706V346.179Z",
    fill: "white"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M154.877 352.465H158.438V348.388H154.877V352.465Z",
    fill: "white"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M148.706 352.465H152.267V348.388H148.706V352.465Z",
    fill: "white"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M154.877 358.817H158.438V354.74H154.877V358.817Z",
    fill: "white"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M148.706 358.817H152.267V354.74H148.706V358.817Z",
    fill: "white"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M154.877 365.168H158.438V361.092H154.877V365.168Z",
    fill: "white"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M148.706 365.168H152.267V361.092H148.706V365.168Z",
    fill: "white"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0749 339.912H68.6357V335.11H65.0749V339.912Z",
    fill: "white"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M58.904 339.912H62.4648V335.11H58.904V339.912Z",
    fill: "white"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0749 347.396H68.6357V342.594H65.0749V347.396Z",
    fill: "white"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M58.904 347.396H62.4648V342.594H58.904V347.396Z",
    fill: "white"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0749 354.879H68.6357V350.077H65.0749V354.879Z",
    fill: "white"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M58.904 354.879H62.4648V350.077H58.904V354.879Z",
    fill: "white"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M141.679 308.922H145.24V304.846H141.679V308.922Z",
    fill: "white"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M135.509 308.922H139.069V304.846H135.509V308.922Z",
    fill: "white"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M141.679 302.634H145.24V298.558H141.679V302.634Z",
    fill: "white"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M135.509 302.634H139.069V298.558H135.509V302.634Z",
    fill: "white"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M141.679 296.344H145.24V292.267H141.679V296.344Z",
    fill: "white"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M135.509 296.344H139.069V292.267H135.509V296.344Z",
    fill: "white"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M141.679 315.056H145.24V310.979H141.679V315.056Z",
    fill: "white"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M135.509 315.056H139.069V310.979H135.509V315.056Z",
    fill: "white"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M141.679 321.189H145.24V317.113H141.679V321.189Z",
    fill: "white"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M135.509 321.189H139.069V317.113H135.509V321.189Z",
    fill: "white"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M141.679 327.323H145.24V323.246H141.679V327.323Z",
    fill: "white"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M135.509 327.323H139.069V323.246H135.509V327.323Z",
    fill: "white"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M141.679 333.608H145.24V329.531H141.679V333.608Z",
    fill: "white"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M135.509 333.608H139.069V329.531H135.509V333.608Z",
    fill: "white"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M141.679 339.893H145.24V335.817H141.679V339.893Z",
    fill: "white"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M135.509 339.893H139.069V335.817H135.509V339.893Z",
    fill: "white"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M141.679 346.179H145.24V342.102H141.679V346.179Z",
    fill: "white"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M135.509 346.179H139.069V342.102H135.509V346.179Z",
    fill: "white"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M141.679 352.465H145.24V348.388H141.679V352.465Z",
    fill: "white"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M135.509 352.465H139.069V348.388H135.509V352.465Z",
    fill: "white"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M141.679 358.817H145.24V354.74H141.679V358.817Z",
    fill: "white"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M135.509 358.817H139.069V354.74H135.509V358.817Z",
    fill: "white"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M141.679 365.168H145.24V361.092H141.679V365.168Z",
    fill: "white"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M135.509 365.168H139.069V361.092H135.509V365.168Z",
    fill: "white"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M463.553 216.594L468.828 208.09L466.224 206.476C465.458 206.002 465.043 205.135 465.12 204.238C465.162 203.742 465.178 203.242 465.167 202.742C465.148 201.843 465.616 201.007 466.408 200.582L469.108 199.134L464.376 190.313L461.677 191.76C460.885 192.185 459.929 192.113 459.192 191.6C458.78 191.314 458.356 191.05 457.919 190.812C457.128 190.379 456.636 189.554 456.665 188.654L456.762 185.591L446.76 185.28L446.667 188.354C446.64 189.255 446.088 190.039 445.272 190.424C445.051 190.528 444.832 190.639 444.614 190.756C444.397 190.873 444.183 190.994 443.974 191.121C443.206 191.585 442.252 191.612 441.489 191.139L438.866 189.514L433.591 198.018L436.2 199.638C436.965 200.113 437.38 200.98 437.302 201.878C437.259 202.372 437.243 202.869 437.253 203.368C437.272 204.266 436.803 205.101 436.012 205.525L433.312 206.973L438.043 215.794L440.743 214.346C441.534 213.922 442.489 213.994 443.226 214.506C443.636 214.79 444.059 215.051 444.495 215.289C445.286 215.721 445.779 216.546 445.751 217.446L445.656 220.516L455.659 220.827L455.754 217.756C455.782 216.858 456.332 216.077 457.145 215.693C457.368 215.588 457.588 215.476 457.808 215.358C458.025 215.242 458.239 215.12 458.449 214.994C459.221 214.527 460.18 214.501 460.946 214.976L463.553 216.594ZM455.084 210.278C451.095 212.418 446.131 210.919 443.992 206.93C441.852 202.941 443.347 197.97 447.336 195.83C451.326 193.691 456.3 195.193 458.44 199.182C460.58 203.171 459.074 208.138 455.084 210.278Z",
    fill: "#DBDBDB"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2535 71.4768L78.7495 65.4048L76.8911 66.4784C76.3447 66.7944 75.6727 66.764 75.1439 66.4192C74.8519 66.2288 74.5487 66.0536 74.2359 65.8944C73.6751 65.6096 73.3143 65.0424 73.3143 64.4128V62.2664H66.3015V64.4128C66.3015 65.0424 65.9407 65.6088 65.3799 65.8944C65.0671 66.0536 64.7639 66.228 64.4719 66.4192C63.9431 66.764 63.2711 66.7944 62.7247 66.4784L60.8663 65.4048L57.3623 71.4768L59.2295 72.5512C59.7767 72.8664 60.0783 73.4672 60.0455 74.0976C60.0367 74.2688 60.0327 74.4408 60.0327 74.6136C60.0327 74.7864 60.0375 74.9584 60.0455 75.1296C60.0775 75.7576 59.7783 76.3552 59.2343 76.6696L57.3623 77.7512L60.8663 83.8232L62.7303 82.7488C63.2775 82.4336 63.9495 82.4648 64.4783 82.8104C64.7695 83 65.0711 83.1752 65.3823 83.3336C65.9423 83.6192 66.3031 84.1856 66.3031 84.8144V86.9608H73.3159V84.8144C73.3159 84.1856 73.6759 83.6192 74.2359 83.3336C74.5471 83.1752 74.8487 83 75.1399 82.8104C75.6687 82.4648 76.3407 82.4336 76.8879 82.7488L78.7511 83.8232L82.2551 77.7512L80.3911 76.676C79.8455 76.3616 79.5463 75.7624 79.5783 75.1336C79.5871 74.9616 79.5911 74.7888 79.5911 74.6136C79.5911 74.4408 79.5871 74.2688 79.5783 74.0976C79.5455 73.4664 79.8471 72.8664 80.3943 72.5504L82.2535 71.4768ZM75.5503 74.6136C75.5503 77.7848 72.9815 80.3536 69.8103 80.3536C66.6391 80.3536 64.0647 77.7848 64.0647 74.6136C64.0647 71.4424 66.6391 68.868 69.8103 68.868C72.9815 68.868 75.5503 71.4424 75.5503 74.6136Z",
    fill: "#DBDBDB"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M510.787 228.507C495.704 228.507 483.483 240.728 483.483 255.81C483.483 270.886 495.704 283.113 510.787 283.113C525.863 283.113 538.09 270.886 538.09 255.81C538.09 240.728 525.863 228.507 510.787 228.507ZM510.787 268.558C503.743 268.558 498.032 262.854 498.032 255.81C498.032 248.766 503.743 243.057 510.787 243.057C517.831 243.057 523.541 248.767 523.541 255.81C523.541 262.854 517.831 268.558 510.787 268.558Z",
    fill: "#EBEBEB"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M516.036 229.639H505.537L506.117 222.207H515.456L516.036 229.639Z",
    fill: "#EBEBEB"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M496.052 233.177L488.628 240.601L483.782 234.935L490.386 228.332L496.052 233.177Z",
    fill: "#EBEBEB"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M484.422 249.809V260.309L476.989 259.729V250.39L484.422 249.809Z",
    fill: "#EBEBEB"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M487.96 269.794L495.384 277.219L489.718 282.064L483.114 275.461L487.96 269.794Z",
    fill: "#EBEBEB"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M504.593 281.425H515.093L514.512 288.857H505.174L504.593 281.425Z",
    fill: "#EBEBEB"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M524.577 277.887L532.001 270.462L536.847 276.128L530.243 282.732L524.577 277.887Z",
    fill: "#EBEBEB"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M536.207 261.254V250.754L543.64 251.335V260.673L536.207 261.254Z",
    fill: "#EBEBEB"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M532.669 241.269L525.245 233.845L530.911 229L537.515 235.603L532.669 241.269Z",
    fill: "#EBEBEB"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M239.616 165.016C224.533 165.016 212.312 177.237 212.312 192.319C212.312 207.395 224.533 219.622 239.616 219.622C254.692 219.622 266.919 207.395 266.919 192.319C266.919 177.237 254.692 165.016 239.616 165.016ZM239.616 205.066C232.572 205.066 226.861 199.362 226.861 192.318C226.861 185.274 232.572 179.565 239.616 179.565C246.659 179.565 252.369 185.275 252.369 192.318C252.37 199.363 246.66 205.066 239.616 205.066Z",
    fill: "#EBEBEB"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M244.865 166.148H234.365L234.946 158.715H244.284L244.865 166.148Z",
    fill: "#EBEBEB"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M224.881 169.685L217.456 177.109L212.611 171.444L219.215 164.84L224.881 169.685Z",
    fill: "#EBEBEB"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M213.251 186.318V196.818L205.818 196.238V186.898L213.251 186.318Z",
    fill: "#EBEBEB"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M216.788 206.303L224.213 213.727L218.547 218.573L211.943 211.969L216.788 206.303Z",
    fill: "#EBEBEB"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M233.421 217.933H243.921L243.34 225.365H234.002L233.421 217.933Z",
    fill: "#EBEBEB"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M253.406 214.395L260.83 206.971L265.675 212.637L259.072 219.24L253.406 214.395Z",
    fill: "#EBEBEB"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M265.036 197.762V187.262L272.468 187.843V197.181L265.036 197.762Z",
    fill: "#EBEBEB"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M261.498 177.777L254.073 170.353L259.74 165.508L266.343 172.112L261.498 177.777Z",
    fill: "#EBEBEB"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M135.009 375.386H137.008L137.008 163.749H135.009L135.009 375.386Z",
    fill: "#C7C7C7"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M133.01 375.386H135.009L135.009 163.749H133.01L133.01 375.386Z",
    fill: "#DBDBDB"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M147.812 375.387H149.811L149.811 195.208H147.812L147.812 375.387Z",
    fill: "#C7C7C7"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M145.813 375.387H147.812L147.812 195.208H145.813L145.813 375.387Z",
    fill: "#DBDBDB"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M161.179 375.386H163.178L163.178 218.802H161.179L161.179 375.386Z",
    fill: "#C7C7C7"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M159.18 375.386H161.179L161.179 218.802H159.18L159.18 375.386Z",
    fill: "#DBDBDB"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0426 375.386H98.041L98.041 146.472H96.0426L96.0426 375.386Z",
    fill: "#C7C7C7"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0436 375.386H96.042L96.042 146.472H94.0436L94.0436 375.386Z",
    fill: "#DBDBDB"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0758 375.386H59.0742L59.0742 146.472H57.0758L57.0758 375.386Z",
    fill: "#C7C7C7"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0768 375.386H57.0752L57.0752 146.472H55.0768L55.0768 375.386Z",
    fill: "#DBDBDB"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0779 336.988H163.179V327.58H55.0779V336.988Z",
    fill: "#DBDBDB"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M117.908 375.386H125.896V371.12H117.908V375.386Z",
    fill: "#DBDBDB"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M113.26 371.12H121.247V366.853H113.26V371.12Z",
    fill: "#DBDBDB"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M108.61 366.854H116.598V362.587H108.61V366.854Z",
    fill: "#DBDBDB"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M103.961 362.587H111.948V358.321H103.961V362.587Z",
    fill: "#DBDBDB"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3126 358.321H107.3V354.054H99.3126V358.321Z",
    fill: "#DBDBDB"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6622 354.054H102.649V349.788H94.6622V354.054Z",
    fill: "#DBDBDB"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0138 349.787H98.001V345.521H90.0138V349.787Z",
    fill: "#DBDBDB"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3644 345.521H93.3516V341.254H85.3644V345.521Z",
    fill: "#DBDBDB"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7149 341.254H88.7021V336.988H80.7149V341.254Z",
    fill: "#DBDBDB"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M117.909 375.386L80.7148 341.254H85.3644L123.024 375.386H117.909Z",
    fill: "#DBDBDB"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0779 289.181H163.179V279.772H55.0779V289.181Z",
    fill: "#DBDBDB"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M117.908 327.579H125.896V323.313H117.908V327.579Z",
    fill: "#DBDBDB"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M113.26 323.313H121.247V319.046H113.26V323.313Z",
    fill: "#DBDBDB"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M108.61 319.046H116.598V314.78H108.61V319.046Z",
    fill: "#DBDBDB"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M103.961 314.78H111.948V310.513H103.961V314.78Z",
    fill: "#DBDBDB"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3126 310.513H107.3V306.247H99.3126V310.513Z",
    fill: "#DBDBDB"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6622 306.247H102.649V301.981H94.6622V306.247Z",
    fill: "#DBDBDB"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0138 301.981H98.001V297.714H90.0138V301.981Z",
    fill: "#DBDBDB"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3644 297.714H93.3516V293.447H85.3644V297.714Z",
    fill: "#DBDBDB"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7149 293.447H88.7021V289.181H80.7149V293.447Z",
    fill: "#DBDBDB"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M117.909 327.579L80.7148 293.447H85.3644L123.024 327.579H117.909Z",
    fill: "#DBDBDB"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0779 241.374H163.179V231.966H55.0779V241.374Z",
    fill: "#DBDBDB"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M117.908 279.773H125.896V275.506H117.908V279.773Z",
    fill: "#DBDBDB"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M113.26 275.506H121.247V271.24H113.26V275.506Z",
    fill: "#DBDBDB"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M108.61 271.24H116.598V266.973H108.61V271.24Z",
    fill: "#DBDBDB"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M103.961 266.973H111.948V262.706H103.961V266.973Z",
    fill: "#DBDBDB"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3126 262.706H107.3V258.44H99.3126V262.706Z",
    fill: "#DBDBDB"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6622 258.44H102.649V254.173H94.6622V258.44Z",
    fill: "#DBDBDB"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0138 254.173H98.001V249.907H90.0138V254.173Z",
    fill: "#DBDBDB"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3644 249.906H93.3516V245.64H85.3644V249.906Z",
    fill: "#DBDBDB"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7149 245.641H88.7021V241.374H80.7149V245.641Z",
    fill: "#DBDBDB"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M117.909 279.772L80.7148 245.641H85.3644L123.024 279.772H117.909Z",
    fill: "#DBDBDB"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M55.077 193.567H133.01V184.158H55.077V193.567Z",
    fill: "#DBDBDB"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M117.908 231.965H125.896V227.699H117.908V231.965Z",
    fill: "#DBDBDB"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M113.26 227.699H121.247V223.433H113.26V227.699Z",
    fill: "#DBDBDB"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M108.61 223.433H116.598V219.166H108.61V223.433Z",
    fill: "#DBDBDB"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M103.961 219.166H111.948V214.9H103.961V219.166Z",
    fill: "#DBDBDB"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3126 214.9H107.3V210.633H99.3126V214.9Z",
    fill: "#DBDBDB"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6622 210.633H102.649V206.367H94.6622V210.633Z",
    fill: "#DBDBDB"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0138 206.366H98.001V202.1H90.0138V206.366Z",
    fill: "#DBDBDB"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3644 202.1H93.3516V197.833H85.3644V202.1Z",
    fill: "#DBDBDB"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7149 197.833H88.7021V193.567H80.7149V197.833Z",
    fill: "#DBDBDB"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M117.909 231.965L80.7148 197.833H85.3644L123.024 231.965H117.909Z",
    fill: "#DBDBDB"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0771 375.386C212.312 374.897 388.69 374.893 545.923 375.386C388.689 375.88 212.311 375.876 55.0771 375.386Z",
    fill: "#263238"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M206.752 52.9856C205.504 64.916 194.816 73.5808 182.885 72.3328C178.064 71.8288 173.777 69.7816 170.458 66.7256L159.591 68.32L165.028 58.9248C163.709 55.7152 163.153 52.1424 163.538 48.4648C164.786 36.5344 175.475 27.8696 187.405 29.1176C199.336 30.3664 208 41.0552 206.752 52.9856Z",
    fill: "white"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M206.752 52.9857C206.298 56.9521 204.848 60.8385 202.368 63.9977C201.798 64.8257 201.064 65.5161 200.399 66.2641C199.644 66.9217 198.94 67.6425 198.106 68.2049C196.518 69.4289 194.732 70.3881 192.866 71.1225C191.009 71.9041 189.011 72.2777 187.018 72.5169C186.013 72.5713 185.006 72.6625 184 72.5745C182.991 72.5513 181.987 72.4441 180.994 72.2617C177.018 71.5417 173.254 69.6809 170.246 66.9553L170.503 67.0345L159.646 68.7009L158.858 68.8217L159.258 68.1273L164.663 58.7137L164.638 59.0857C162.005 52.8857 162.598 45.5017 165.977 39.7241C167.66 36.8313 170.009 34.3385 172.78 32.4793C175.55 30.6145 178.762 29.4457 182.051 29.0009C185.343 28.5641 188.73 28.8641 191.874 29.9089C195.014 30.9665 197.893 32.7441 200.251 35.0457C205.047 39.6049 207.458 46.4449 206.752 52.9857ZM206.752 52.9857C207.412 46.4393 204.954 39.6409 200.156 35.1433C197.774 32.8937 194.89 31.1897 191.779 30.2009C188.662 29.2257 185.328 28.9929 182.118 29.4769C178.91 29.9697 175.802 31.1641 173.146 33.0209C170.497 34.8817 168.262 37.3153 166.647 40.1105C165.001 42.8993 164.148 46.0945 163.89 49.3025C163.687 52.5209 164.212 55.7777 165.419 58.7657L165.498 58.9601L165.394 59.1377L159.924 68.5137L159.535 67.9401L170.413 66.4169L170.563 66.3961L170.67 66.4969C173.545 69.1961 177.184 71.0801 181.072 71.8545C182.043 72.0505 183.028 72.1737 184.019 72.2129C185.009 72.3177 186 72.2441 186.992 72.2081C188.959 72.0057 190.942 71.6729 192.794 70.9305C194.653 70.2345 196.45 69.3209 198.034 68.1065C198.866 67.5529 199.571 66.8409 200.328 66.1913C200.995 65.4513 201.731 64.7681 202.304 63.9473C204.796 60.8169 206.271 56.9489 206.752 52.9857Z",
    fill: "#263238"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M182.394 63.1145L173.116 53.7225L176.233 50.6425L181.653 56.1281L192.913 38.4761L196.608 40.8321L182.394 63.1145Z",
    fill: "#514EFF"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M210.862 371.826C208.821 372.46 150.761 371.215 148.573 369.776C147.745 369.235 147.436 360.759 147.351 350.519C147.328 348.307 147.328 346.033 147.336 343.705C147.336 343.218 150.793 314.223 150.793 314.223L188.024 314.919L185.101 344.402L184.784 351.215C184.784 351.215 206.795 361.633 209.022 363.482C211.233 365.314 212.904 371.191 210.862 371.826Z",
    fill: "#D3766A"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M210.862 371.826C208.821 372.46 150.761 371.215 148.573 369.776C147.745 369.235 147.436 360.759 147.351 350.519C147.328 348.307 147.328 346.033 147.336 343.705C147.336 343.218 147.517 341.293 147.694 339.569L185.511 340.248L185.101 344.401L184.785 351.215C184.785 351.215 206.796 361.632 209.023 363.481C211.233 365.314 212.904 371.192 210.862 371.826Z",
    fill: "#EBEBEB"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M211.732 370.13V374.557C211.732 375.016 211.359 375.387 210.897 375.387H210.631C210.234 375.387 209.918 375.103 209.812 374.723C209.519 373.667 208.543 372.888 207.387 372.888C206.226 372.888 205.248 373.667 204.955 374.723C204.849 375.103 204.533 375.387 204.136 375.387H202.867C202.471 375.387 202.155 375.103 202.05 374.723C201.758 373.667 200.786 372.888 199.625 372.888C198.47 372.888 197.494 373.667 197.2 374.723C197.095 375.103 196.779 375.387 196.382 375.387H195.113C194.716 375.387 194.4 375.103 194.295 374.723C194.001 373.667 193.025 372.888 191.87 372.888C190.708 372.888 189.731 373.667 189.437 374.723C189.331 375.103 189.015 375.387 188.619 375.387H187.35C186.954 375.387 186.638 375.103 186.533 374.723C186.241 373.667 185.269 372.888 184.107 372.888C182.952 372.888 181.976 373.667 181.683 374.723C181.577 375.103 181.261 375.387 180.864 375.387H179.595C179.199 375.387 178.883 375.103 178.777 374.723C178.483 373.667 177.507 372.888 176.352 372.888C175.191 372.888 174.213 373.667 173.92 374.723C173.815 375.103 173.499 375.387 173.102 375.387H171.833C171.436 375.387 171.121 375.103 171.016 374.723C170.724 373.667 169.752 372.888 168.591 372.888C167.435 372.888 166.459 373.667 166.166 374.723C166.06 375.103 165.744 375.387 165.347 375.387H164.079C163.682 375.387 163.366 375.103 163.26 374.723C162.967 373.667 161.991 372.888 160.835 372.888C159.674 372.888 158.696 373.667 158.403 374.723C158.297 375.103 157.981 375.387 157.584 375.387H156.315C155.919 375.387 155.603 375.103 155.498 374.723C155.206 373.667 154.234 372.888 153.073 372.888C151.918 372.888 150.942 373.667 150.648 374.723C150.543 375.103 150.227 375.387 149.83 375.387H148.925C148.463 375.387 148.09 375.016 148.09 374.557V370.13C148.09 369.671 148.463 369.3 148.925 369.3H210.894C211.358 369.3 211.732 369.671 211.732 370.13Z",
    fill: "#514EFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.732 370.13V374.557C211.732 375.016 211.359 375.387 210.897 375.387H210.631C210.234 375.387 209.918 375.103 209.812 374.723C209.519 373.667 208.543 372.888 207.387 372.888C206.226 372.888 205.248 373.667 204.955 374.723C204.849 375.103 204.533 375.387 204.136 375.387H202.867C202.471 375.387 202.155 375.103 202.05 374.723C201.758 373.667 200.786 372.888 199.625 372.888C198.47 372.888 197.494 373.667 197.2 374.723C197.095 375.103 196.779 375.387 196.382 375.387H195.113C194.716 375.387 194.4 375.103 194.295 374.723C194.001 373.667 193.025 372.888 191.87 372.888C190.708 372.888 189.731 373.667 189.437 374.723C189.331 375.103 189.015 375.387 188.619 375.387H187.35C186.954 375.387 186.638 375.103 186.533 374.723C186.241 373.667 185.269 372.888 184.107 372.888C182.952 372.888 181.976 373.667 181.683 374.723C181.577 375.103 181.261 375.387 180.864 375.387H179.595C179.199 375.387 178.883 375.103 178.777 374.723C178.483 373.667 177.507 372.888 176.352 372.888C175.191 372.888 174.213 373.667 173.92 374.723C173.815 375.103 173.499 375.387 173.102 375.387H171.833C171.436 375.387 171.121 375.103 171.016 374.723C170.724 373.667 169.752 372.888 168.591 372.888C167.435 372.888 166.459 373.667 166.166 374.723C166.06 375.103 165.744 375.387 165.347 375.387H164.079C163.682 375.387 163.366 375.103 163.26 374.723C162.967 373.667 161.991 372.888 160.835 372.888C159.674 372.888 158.696 373.667 158.403 374.723C158.297 375.103 157.981 375.387 157.584 375.387H156.315C155.919 375.387 155.603 375.103 155.498 374.723C155.206 373.667 154.234 372.888 153.073 372.888C151.918 372.888 150.942 373.667 150.648 374.723C150.543 375.103 150.227 375.387 149.83 375.387H148.925C148.463 375.387 148.09 375.016 148.09 374.557V370.13C148.09 369.671 148.463 369.3 148.925 369.3H210.894C211.358 369.3 211.732 369.671 211.732 370.13Z",
    fill: "black"
  }))), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M211.038 371.914C209.706 372.325 184.973 371.955 166.974 371.249C162.809 371.083 159.001 370.897 155.929 370.707C151.696 370.433 148.857 370.149 148.401 369.847C147.391 369.171 147.133 356.743 147.144 343.636L185.129 344.339L184.806 351.185C184.806 351.185 206.944 361.663 209.184 363.517C211.407 365.371 213.084 371.267 211.038 371.914Z",
    fill: "#514EFF"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M211.038 371.914C209.706 372.325 184.973 371.955 166.974 371.249C162.809 371.083 159.001 370.897 155.929 370.707C151.696 370.433 148.857 370.149 148.401 369.847C147.391 369.171 147.133 356.743 147.144 343.636L185.129 344.339L184.806 351.185C184.806 351.185 206.944 361.663 209.184 363.517C211.407 365.371 213.084 371.267 211.038 371.914Z",
    fill: "#514EFF"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M210.249 369.561C200.467 369.111 160.973 368.22 151.27 368.518C151.191 368.521 151.19 368.574 151.269 368.58C160.954 369.238 200.455 369.809 210.246 369.722C210.453 369.719 210.455 369.57 210.249 369.561Z",
    fill: "#263238"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M186.237 349.042C182.401 348.24 177.678 348.73 174.677 351.411C174.561 351.515 174.709 351.679 174.835 351.642C178.661 350.526 182.225 349.834 186.211 349.528C186.491 349.506 186.51 349.099 186.237 349.042Z",
    fill: "#263238"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M188.979 350.777C185.143 349.975 180.421 350.466 177.419 353.146C177.302 353.25 177.452 353.414 177.578 353.378C181.402 352.261 184.967 351.568 188.954 351.263C189.234 351.242 189.254 350.834 188.979 350.777Z",
    fill: "#263238"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M191.723 352.511C187.887 351.711 183.165 352.201 180.163 354.881C180.047 354.985 180.196 355.149 180.322 355.112C184.147 353.996 187.712 353.303 191.697 352.998C191.978 352.976 191.998 352.569 191.723 352.511Z",
    fill: "#263238"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M194.467 354.246C190.631 353.445 185.909 353.935 182.907 356.617C182.791 356.721 182.94 356.884 183.066 356.848C186.891 355.732 190.456 355.039 194.441 354.734C194.722 354.71 194.741 354.303 194.467 354.246Z",
    fill: "#263238"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M193.539 340.288C192.071 338.171 189.232 339.049 187.596 340.365C184.946 342.497 182.594 345.865 181.476 349.06C181.449 349.139 181.501 349.188 181.563 349.201C181.568 349.494 181.825 349.81 182.157 349.695C185.363 348.585 188.927 347.796 191.695 345.736C193.312 344.534 194.928 342.291 193.539 340.288ZM186.673 347.019C185.11 347.603 183.527 348.107 181.987 348.748C183.185 347.055 184.304 345.32 185.672 343.749C186.325 342.999 187.01 342.242 187.761 341.587C188.928 340.569 193.512 338.448 192.743 342.659C192.319 344.98 188.535 346.323 186.673 347.019Z",
    fill: "#263238"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M171.709 347.845C174.855 349.266 178.505 349.275 181.873 349.674C182.223 349.716 182.405 349.353 182.347 349.065C182.407 349.039 182.447 348.979 182.403 348.909C180.629 346.027 177.612 343.239 174.567 341.722C172.687 340.785 169.727 340.534 168.744 342.916C167.815 345.169 169.873 347.015 171.709 347.845ZM170.029 345.062C168.378 341.112 173.309 342.206 174.667 342.951C175.54 343.43 176.371 344.024 177.169 344.617C178.841 345.859 180.305 347.316 181.838 348.714C180.195 348.416 178.542 348.262 176.89 348.026C174.922 347.743 170.939 347.239 170.029 345.062Z",
    fill: "#263238"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M181.32 371.704C176.433 371.579 171.489 371.418 166.97 371.243C162.807 371.086 158.999 370.901 155.927 370.706C151.696 370.432 148.855 370.15 148.402 369.843C147.518 369.253 147.202 359.651 147.156 348.471C155.773 354.232 172.707 365.806 181.32 371.704Z",
    fill: "black"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M187.235 339.151L146.878 338.636C146.878 338.636 155.656 258.971 155.354 257.291C154.971 255.139 129.08 153.623 129.08 153.623H163.906C163.906 153.623 191.37 248.24 192.356 257.358C193.953 272.078 187.235 339.151 187.235 339.151Z",
    fill: "#455A64"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M152.48 330.398C154.636 330.243 156.816 330.27 158.977 330.241C161.141 330.213 163.306 330.206 165.47 330.227C169.797 330.27 174.123 330.335 178.449 330.458C179.632 330.491 180.815 330.527 181.998 330.582C183.265 330.64 184.526 330.856 185.788 330.903C185.887 330.906 185.883 331.055 185.784 331.057C184.722 331.066 183.658 331.225 182.594 331.255C181.492 331.287 180.389 331.294 179.286 331.294C177.122 331.294 174.958 331.287 172.794 331.27C168.468 331.234 164.138 331.175 159.815 330.997C157.374 330.896 154.906 330.866 152.474 330.621C152.331 330.606 152.338 330.408 152.48 330.398Z",
    fill: "#263238"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M136.74 161.822C139.856 172.857 142.705 183.99 145.498 195.11C148.293 206.238 151.071 217.37 153.841 228.502C155.226 234.069 156.611 239.636 157.995 245.202C159.343 250.622 160.909 256.07 161.243 261.67C161.583 267.365 160.859 273.105 160.379 278.772C159.895 284.47 159.419 290.169 158.92 295.865C157.922 307.262 157.738 310.936 156.499 322.31C156.343 323.733 156.191 325.156 156.047 326.581C156.035 326.702 155.847 326.7 155.855 326.576C156.61 315.171 156.623 311.506 157.533 300.113C157.988 294.414 158.454 288.716 158.925 283.018C159.395 277.332 160.056 271.625 160.236 265.921C160.418 260.162 159.365 254.65 157.976 249.09C156.615 243.642 155.247 238.195 153.883 232.748C151.096 221.618 148.307 210.49 145.545 199.354C142.452 186.888 139.365 174.398 136.636 161.846C136.622 161.78 136.722 161.755 136.74 161.822Z",
    fill: "#263238"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M129.078 153.625C129.078 153.625 140.187 197.176 147.959 227.833L162.777 153.625H129.078Z",
    fill: "black"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M166.606 371.823C164.559 372.461 106.501 371.217 104.315 369.773C103.49 369.234 103.176 360.759 103.09 350.52C103.068 348.307 103.066 346.032 103.074 343.704C103.08 340.958 104.986 314.222 104.986 314.222L142.22 314.922L140.846 344.403L140.524 351.214C140.524 351.214 162.538 361.636 164.761 363.481C166.975 365.316 168.644 371.194 166.606 371.823Z",
    fill: "#D3766A"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M166.61 371.826C164.56 372.46 106.502 371.214 104.312 369.776C103.492 369.234 103.175 360.758 103.09 350.518C103.067 348.306 103.067 346.033 103.075 343.705C103.075 343.21 103.145 341.918 103.246 340.139H141.05L140.849 344.401L140.524 351.214C140.524 351.214 162.542 361.632 164.762 363.481C166.973 365.314 168.643 371.191 166.61 371.826Z",
    fill: "#EBEBEB"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M167.474 370.13V374.557C167.474 375.015 167.1 375.386 166.639 375.386H166.372C165.976 375.386 165.66 375.103 165.554 374.723C165.26 373.667 164.284 372.888 163.129 372.888C161.968 372.888 160.99 373.667 160.696 374.723C160.591 375.103 160.275 375.386 159.878 375.386H158.609C158.213 375.386 157.897 375.103 157.792 374.723C157.5 373.667 156.528 372.888 155.367 372.888C154.212 372.888 153.236 373.667 152.942 374.723C152.836 375.103 152.52 375.386 152.124 375.386H150.855C150.458 375.386 150.142 375.103 150.036 374.723C149.743 373.667 148.767 372.888 147.612 372.888C146.45 372.888 145.472 373.667 145.179 374.723C145.073 375.103 144.757 375.386 144.36 375.386H143.092C142.695 375.386 142.379 375.103 142.274 374.723C141.982 373.667 141.01 372.888 139.849 372.888C138.694 372.888 137.718 373.667 137.424 374.723C137.319 375.103 137.003 375.386 136.606 375.386H135.337C134.94 375.386 134.624 375.103 134.519 374.723C134.225 373.667 133.249 372.888 132.094 372.888C130.932 372.888 129.955 373.667 129.661 374.723C129.556 375.103 129.24 375.386 128.843 375.386H127.574C127.177 375.386 126.861 375.103 126.756 374.723C126.464 373.667 125.492 372.888 124.331 372.888C123.176 372.888 122.2 373.667 121.906 374.723C121.8 375.103 121.484 375.386 121.088 375.386H119.819C119.422 375.386 119.106 375.103 119 374.723C118.707 373.667 117.731 372.888 116.576 372.888C115.414 372.888 114.436 373.667 114.143 374.723C114.037 375.103 113.721 375.386 113.324 375.386H112.056C111.66 375.386 111.344 375.103 111.238 374.723C110.946 373.667 109.974 372.888 108.813 372.888C107.659 372.888 106.682 373.667 106.388 374.723C106.283 375.103 105.967 375.386 105.57 375.386H104.665C104.204 375.386 103.83 375.015 103.83 374.557V370.13C103.83 369.671 104.204 369.3 104.665 369.3H166.634C167.1 369.3 167.474 369.671 167.474 370.13Z",
    fill: "#514EFF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.474 370.13V374.557C167.474 375.015 167.1 375.386 166.639 375.386H166.372C165.976 375.386 165.66 375.103 165.554 374.723C165.26 373.667 164.284 372.888 163.129 372.888C161.968 372.888 160.99 373.667 160.696 374.723C160.591 375.103 160.275 375.386 159.878 375.386H158.609C158.213 375.386 157.897 375.103 157.792 374.723C157.5 373.667 156.528 372.888 155.367 372.888C154.212 372.888 153.236 373.667 152.942 374.723C152.836 375.103 152.52 375.386 152.124 375.386H150.855C150.458 375.386 150.142 375.103 150.036 374.723C149.743 373.667 148.767 372.888 147.612 372.888C146.45 372.888 145.472 373.667 145.179 374.723C145.073 375.103 144.757 375.386 144.36 375.386H143.092C142.695 375.386 142.379 375.103 142.274 374.723C141.982 373.667 141.01 372.888 139.849 372.888C138.694 372.888 137.718 373.667 137.424 374.723C137.319 375.103 137.003 375.386 136.606 375.386H135.337C134.94 375.386 134.624 375.103 134.519 374.723C134.225 373.667 133.249 372.888 132.094 372.888C130.932 372.888 129.955 373.667 129.661 374.723C129.556 375.103 129.24 375.386 128.843 375.386H127.574C127.177 375.386 126.861 375.103 126.756 374.723C126.464 373.667 125.492 372.888 124.331 372.888C123.176 372.888 122.2 373.667 121.906 374.723C121.8 375.103 121.484 375.386 121.088 375.386H119.819C119.422 375.386 119.106 375.103 119 374.723C118.707 373.667 117.731 372.888 116.576 372.888C115.414 372.888 114.436 373.667 114.143 374.723C114.037 375.103 113.721 375.386 113.324 375.386H112.056C111.66 375.386 111.344 375.103 111.238 374.723C110.946 373.667 109.974 372.888 108.813 372.888C107.659 372.888 106.682 373.667 106.388 374.723C106.283 375.103 105.967 375.386 105.57 375.386H104.665C104.204 375.386 103.83 375.015 103.83 374.557V370.13C103.83 369.671 104.204 369.3 104.665 369.3H166.634C167.1 369.3 167.474 369.671 167.474 370.13Z",
    fill: "black"
  }))), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M166.779 371.914C165.447 372.325 140.714 371.955 122.715 371.249C118.55 371.083 114.742 370.897 111.671 370.707C107.437 370.433 104.599 370.149 104.142 369.847C103.132 369.171 102.874 356.743 102.885 343.636L140.87 344.339L140.548 351.185C140.548 351.185 162.685 361.663 164.925 363.517C167.149 365.371 168.826 371.267 166.779 371.914Z",
    fill: "#514EFF"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M166.779 371.914C165.447 372.325 140.714 371.955 122.715 371.249C118.55 371.083 114.742 370.897 111.671 370.707C107.437 370.433 104.599 370.149 104.142 369.847C103.132 369.171 102.874 356.743 102.885 343.636L140.87 344.339L140.548 351.185C140.548 351.185 162.685 361.663 164.925 363.517C167.149 365.371 168.826 371.267 166.779 371.914Z",
    fill: "#514EFF"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M165.991 369.561C156.21 369.111 116.715 368.22 107.012 368.518C106.933 368.521 106.932 368.574 107.011 368.58C116.696 369.238 156.197 369.809 165.988 369.722C166.195 369.719 166.198 369.57 165.991 369.561Z",
    fill: "#263238"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M141.977 349.042C138.141 348.24 133.419 348.73 130.417 351.411C130.3 351.515 130.45 351.679 130.576 351.642C134.401 350.526 137.965 349.834 141.951 349.528C142.232 349.506 142.252 349.099 141.977 349.042Z",
    fill: "#263238"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M144.722 350.777C140.887 349.975 136.164 350.466 133.162 353.146C133.046 353.25 133.195 353.414 133.32 353.378C137.145 352.261 140.71 351.568 144.696 351.263C144.977 351.242 144.996 350.834 144.722 350.777Z",
    fill: "#263238"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M147.465 352.511C143.629 351.711 138.907 352.201 135.905 354.881C135.789 354.985 135.938 355.149 136.064 355.112C139.889 353.996 143.454 353.303 147.44 352.998C147.72 352.976 147.74 352.569 147.465 352.511Z",
    fill: "#263238"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M150.209 354.246C146.373 353.445 141.651 353.935 138.649 356.617C138.533 356.721 138.682 356.884 138.808 356.848C142.634 355.732 146.198 355.039 150.184 354.734C150.464 354.71 150.484 354.303 150.209 354.246Z",
    fill: "#263238"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M149.282 340.288C147.813 338.171 144.974 339.049 143.338 340.365C140.688 342.497 138.336 345.865 137.218 349.06C137.191 349.139 137.243 349.188 137.306 349.201C137.311 349.494 137.568 349.81 137.9 349.695C141.106 348.585 144.67 347.796 147.438 345.736C149.054 344.534 150.67 342.291 149.282 340.288ZM142.415 347.019C140.852 347.603 139.27 348.107 137.729 348.748C138.927 347.055 140.046 345.32 141.414 343.749C142.067 342.999 142.752 342.242 143.502 341.587C144.67 340.569 149.254 338.448 148.485 342.659C148.061 344.98 144.278 346.323 142.415 347.019Z",
    fill: "#263238"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M127.451 347.845C130.597 349.266 134.247 349.275 137.615 349.674C137.965 349.716 138.147 349.353 138.09 349.065C138.149 349.039 138.189 348.979 138.146 348.909C136.371 346.027 133.354 343.239 130.31 341.722C128.43 340.785 125.47 340.534 124.486 342.916C123.558 345.169 125.615 347.015 127.451 347.845ZM125.771 345.062C124.12 341.112 129.051 342.206 130.41 342.951C131.282 343.43 132.114 344.024 132.911 344.617C134.583 345.859 136.047 347.316 137.579 348.714C135.937 348.416 134.283 348.262 132.631 348.026C130.663 347.743 126.682 347.239 125.771 345.062Z",
    fill: "#263238"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M162.782 153.609C162.782 153.609 161.77 170.261 157.79 183.41C157.47 184.498 157.126 185.567 156.754 186.593C156.754 186.593 152.765 187.983 146.652 191.626C146.652 191.626 144.916 255.322 144.962 259.277C145.126 274.076 143.663 338.418 143.663 338.418L100.682 338.069C100.682 338.069 107.59 264.295 107.605 258.874C107.623 253.632 110.108 220.558 112.329 191.882C112.329 191.882 109.056 182.722 109.418 178.095C110.297 166.88 115.326 153.623 115.326 153.623L162.782 153.609Z",
    fill: "#455A64"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M154.744 175.975C154.882 175.054 155.021 174.132 155.162 173.211C155.421 171.523 155.765 169.846 156.061 168.164C156.732 164.347 157.429 160.519 158.279 156.737C158.3 156.645 158.454 156.668 158.444 156.763C158.293 158.29 158.118 159.815 157.902 161.334C157.685 162.855 157.535 164.384 157.321 165.904C156.895 168.919 156.475 171.939 155.962 174.939C155.765 176.095 155.043 178.168 156.708 178.527C158.026 178.811 158.992 177.517 159.38 176.431C159.852 175.109 160.02 173.646 160.266 172.268C160.537 170.747 160.777 169.219 160.993 167.689C161.462 164.355 161.979 161.035 162.521 157.712C162.537 157.617 162.689 157.646 162.686 157.739C162.58 161.162 162.399 164.551 161.949 167.95C161.733 169.572 161.492 171.191 161.217 172.803C160.96 174.311 160.768 175.932 160.102 177.324C159.579 178.416 158.602 179.401 157.347 179.535C157.321 179.538 157.296 179.536 157.27 179.538C157.299 179.56 157.321 179.59 157.319 179.634C157.301 180.174 157.312 180.721 157.254 181.259C157.198 181.791 157.092 182.325 156.99 182.851C156.888 183.382 156.76 183.927 156.578 184.437C156.49 184.684 156.399 184.93 156.286 185.166C156.166 185.413 156 185.605 155.855 185.836C155.797 185.93 155.684 185.871 155.678 185.78L155.669 185.781C155.677 185.691 155.678 185.604 155.68 185.517C155.679 185.501 155.682 185.486 155.681 185.471L155.682 185.469C155.686 185.312 155.689 185.156 155.713 184.996C155.751 184.736 155.809 184.479 155.866 184.223C155.979 183.71 156.12 183.198 156.257 182.691C156.395 182.183 156.505 181.669 156.636 181.16C156.771 180.635 156.943 180.123 157.065 179.594C157.07 179.57 157.086 179.559 157.101 179.544C156.122 179.556 155.133 179.036 154.778 178.088C154.521 177.4 154.638 176.681 154.744 175.975Z",
    fill: "#263238"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M143.676 192.891C144.729 192.027 145.97 191.311 147.137 190.61C148.408 189.847 149.724 189.156 151.084 188.566C153.745 187.411 156.489 186.621 159.237 185.713C159.318 185.686 159.373 185.823 159.292 185.855C156.632 186.913 154.081 188.317 151.511 189.575C150.246 190.195 148.965 190.783 147.677 191.352C146.387 191.923 145.101 192.589 143.777 193.074C143.675 193.11 143.595 192.958 143.676 192.891Z",
    fill: "#263238"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M122.902 169.694C124.774 169.686 126.638 169.414 128.448 168.947C129.284 168.732 130.11 168.465 130.929 168.196C131.716 167.938 132.532 167.621 133.167 167.073C134.428 165.986 135.016 164.273 135.563 162.753C136.181 161.035 136.628 159.287 137.016 157.507C137.036 157.419 137.164 157.448 137.166 157.531C137.226 159.527 136.94 161.561 136.411 163.487C135.959 165.13 135.35 166.965 134.022 168.117C132.624 169.329 130.727 169.755 128.939 169.976C126.92 170.226 124.907 170.167 122.896 169.893C122.773 169.876 122.771 169.695 122.902 169.694Z",
    fill: "#263238"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M105.401 330.938C107.557 330.783 109.737 330.809 111.898 330.78C114.062 330.752 116.227 330.745 118.391 330.767C122.718 330.809 127.044 330.875 131.37 330.997C132.554 331.031 133.737 331.067 134.92 331.121C136.186 331.179 137.446 331.395 138.709 331.443C138.808 331.446 138.804 331.595 138.705 331.596C137.644 331.606 136.58 331.764 135.516 331.795C134.413 331.827 133.31 331.834 132.207 331.834C130.043 331.834 127.879 331.827 125.715 331.809C121.389 331.773 117.059 331.715 112.736 331.536C110.294 331.435 107.828 331.405 105.396 331.16C105.252 331.146 105.259 330.948 105.401 330.938Z",
    fill: "#263238"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M109.89 326.147C109.883 326.147 109.875 326.147 109.867 326.146C109.62 326.135 109.43 325.923 109.441 325.676L117.747 190.779C117.642 190.154 115.301 182.187 115.091 178.118C114.871 173.815 119.319 157.048 119.508 156.337C119.572 156.097 119.823 155.959 120.057 156.019C120.296 156.083 120.438 156.328 120.375 156.567C120.329 156.74 115.774 173.909 115.987 178.072C116.202 182.279 118.627 190.609 118.639 190.677C118.645 190.71 110.337 325.719 110.337 325.719C110.326 325.96 110.127 326.147 109.89 326.147Z",
    fill: "#263238"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M143.212 109.383C158.219 116.227 177.036 122.278 181.081 121.031C190.855 118.022 205.321 108.985 208.783 105.913C211.035 103.915 198.648 84.4538 196.019 86.2754C187.246 92.3538 180.076 99.0842 178.559 99.7378C176.143 100.779 153.761 99.1506 144.239 99.2114C134.681 99.2738 133.852 105.115 143.212 109.383Z",
    fill: "#D3766A"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M218.863 98.6179C215.719 102.603 206.102 108.241 203.259 108.708C200.416 109.175 190.29 93.1435 191.3 90.3651C192.311 87.5867 203.935 74.9867 208.981 73.8171C214.026 72.6467 222.12 94.4883 218.863 98.6179Z",
    fill: "#D3766A"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M192.901 87.8698C192.901 87.8698 194.852 81.561 194.616 75.749C194.417 70.8618 193.57 63.6266 196.194 63.4218C201.581 63.001 203.687 81.0442 203.687 81.0442C203.687 81.0442 203.338 89.1538 198.037 90.0442C194.713 90.6018 192.901 87.8698 192.901 87.8698Z",
    fill: "#D3766A"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M201.581 77.1745C201.248 79.8433 204.584 78.7073 204.584 78.7073C204.584 78.7073 200.177 81.4993 200.898 84.3841C201.601 87.1617 205.582 85.6473 205.869 85.5433C205.637 85.6929 201.654 88.3649 202.677 91.1881C203.744 94.1217 207.479 91.9153 207.72 91.7721C207.545 91.9825 205.285 94.8001 206.549 96.7681C208.725 100.15 214.705 93.1049 217.958 92.9761C217.958 92.9761 218.806 98.4641 218.864 98.6185C218.864 98.6185 224.69 92.0321 224.271 87.6545C224.05 85.3465 221.856 85.0969 221.856 85.0969C221.856 85.0969 223.969 83.1809 223.233 80.9329C222.853 79.7801 220.669 79.3625 220.669 79.3625C220.669 79.3625 222.297 77.7577 221.518 75.7985C220.901 74.2329 218.807 74.0585 218.807 74.0585C218.807 74.0585 219.655 71.7921 218.505 70.3977C216.193 67.5777 202.297 71.4601 201.581 77.1745Z",
    fill: "#D3766A"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M218.48 73.9776C218.527 73.9688 218.524 73.9008 218.473 73.9024C213.592 74.064 208.278 75.7376 204.396 78.7496C204.269 78.848 204.374 79.0984 204.535 79.016C209.131 76.676 213.395 74.9664 218.48 73.9776Z",
    fill: "#263238"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M220.73 79.3137C220.785 79.3033 220.768 79.2113 220.708 79.2137C215.68 79.4073 209.746 81.4569 205.681 85.4553C205.542 85.5929 205.554 85.8553 205.727 85.7097C208.631 83.2561 216.148 80.1801 220.73 79.3137Z",
    fill: "#263238"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M207.532 92.1481C211.578 88.4649 216.398 86.4489 221.647 85.0897C221.715 85.0721 221.683 84.9769 221.622 84.9761C218.873 84.9409 215.618 86.1561 213.165 87.3153C210.816 88.4265 208.92 89.9001 207.403 92.0057C207.345 92.0889 207.445 92.2273 207.532 92.1481Z",
    fill: "#263238"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M204.496 78.6809C204.343 78.8001 204.684 78.8921 204.536 79.0153C203.909 79.5353 200.408 82.9865 201.213 84.5441C201.862 85.7913 203.987 85.7849 204.802 85.4625L206.852 84.6513L205.208 86.1265C204.491 86.7705 203.824 87.5513 203.357 88.3889C202.89 89.2233 202.646 90.1793 202.943 90.9945C203.236 91.8521 203.944 92.3961 204.836 92.3361C205.719 92.3129 206.679 91.9049 207.472 91.4105L209.69 90.0289L208.053 92.0505C207.61 92.5985 207.204 93.2401 206.915 93.8905C206.629 94.5417 206.448 95.2481 206.568 95.8761C206.684 96.4921 207.138 97.0521 207.72 97.1937C208.332 97.3513 209.073 97.1641 209.756 96.9185C211.147 96.4001 212.445 95.5753 213.772 94.8225C214.434 94.4401 215.098 94.0545 215.781 93.7017C216.463 93.3641 217.18 93.0009 217.956 92.9745C217.192 93.0801 216.537 93.5089 215.884 93.8865C215.237 94.2865 214.608 94.7185 213.977 95.1505C212.715 96.0145 211.435 96.8705 209.987 97.5065C209.26 97.7953 208.461 98.0833 207.556 97.9137C206.622 97.7313 205.949 96.9073 205.78 96.0353C205.604 95.1465 205.838 94.3025 206.144 93.5601C206.468 92.8105 206.874 92.1409 207.382 91.4921L207.963 92.1321C207.029 92.7233 206.041 93.1889 204.859 93.2569C204.277 93.2873 203.628 93.1305 203.124 92.7457C202.616 92.3617 202.295 91.8401 202.103 91.2793C201.711 90.1113 202.091 88.9025 202.627 87.9801C203.18 87.0313 203.881 86.2385 204.701 85.5233L205.108 86.1873C204.057 86.5617 201.682 86.8281 200.433 85.0201C199.16 82.4209 203.636 79.2105 204.496 78.6809Z",
    fill: "#263238"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M204.584 78.7073C204 78.7713 203.427 78.7785 202.933 78.6753C202.438 78.5753 202.079 78.2769 201.948 77.8817C201.806 77.4873 201.9 76.9561 202.044 76.4401C202.207 75.9233 202.403 75.3881 202.628 74.8433C202.167 75.2153 201.779 75.6777 201.5 76.2185C201.229 76.7529 201.016 77.4089 201.235 78.1249C201.369 78.4705 201.592 78.7665 201.892 78.9697C202.198 79.1633 202.542 79.2529 202.865 79.2561C203.516 79.2737 204.097 79.0417 204.584 78.7073Z",
    fill: "#263238"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M170.85 120.096L175.854 99.4425C175.854 99.4425 156.129 98.3177 142.958 98.9865C131.794 99.5529 131.596 106.228 139.278 109.361C149.376 113.479 170.85 120.096 170.85 120.096Z",
    fill: "#EBEBEB"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M172.036 121.96L178.163 99.0066L177.294 99.3194L176.632 97.9682L175.973 98.2058L174.106 97.6946L168.74 120.855L169.655 120.527L170.449 121.591L171.243 121.188L172.036 121.96Z",
    fill: "#DBDBDB"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M140.203 89.1689C139.898 86.5513 132.405 76.7025 122.817 82.4841C113.374 88.1785 118.42 104.504 129.884 102.888C137.584 101.802 140.851 94.7273 140.203 89.1689Z",
    fill: "#263238"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M164.439 154.046L159.847 133.855C159.847 133.855 164.664 128.016 161.437 121.244C159.808 117.814 150.436 102.865 144.512 98.6656C138.955 94.7264 132.117 98.6448 129.588 102.154C122.315 112.243 117.42 132.413 114.219 154.606L164.439 154.046Z",
    fill: "#EBEBEB"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M164.438 154.044L159.843 133.85C159.843 133.85 164.662 128.011 161.437 121.244C160.61 119.504 157.786 114.786 154.43 110.022L136.494 110.75C136.494 110.75 136.496 115.758 132.388 124.214C130.616 127.862 121.576 131.646 118.134 132.846C116.611 139.644 115.319 147.006 114.221 154.609L164.438 154.044Z",
    fill: "#455A64"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M152.099 131.355C149.588 131.664 147.069 132.059 144.629 132.737C143.414 133.075 142.223 133.465 141.034 133.883C140.441 134.092 139.846 134.279 139.246 134.465C138.63 134.655 137.969 134.834 137.322 134.867C137.264 134.871 137.268 134.957 137.325 134.958C137.955 134.963 138.558 134.966 139.185 134.887C139.78 134.811 140.371 134.672 140.951 134.517C142.186 134.187 143.405 133.799 144.637 133.457C147.121 132.765 149.605 132.075 152.134 131.563C152.251 131.539 152.218 131.34 152.099 131.355Z",
    fill: "#263238"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M158.383 133.467C156.309 133.298 154.195 133.224 152.115 133.291C151.068 133.324 150.032 133.418 148.992 133.539C148.495 133.598 148 133.664 147.506 133.737C146.962 133.817 146.428 133.971 145.883 134.043C145.827 134.051 145.828 134.139 145.887 134.134C146.403 134.081 146.929 134.114 147.447 134.091C147.968 134.068 148.488 134.041 149.009 134.018C150.051 133.972 151.094 133.937 152.136 133.881C154.223 133.769 156.3 133.678 158.389 133.638C158.502 133.637 158.49 133.476 158.383 133.467Z",
    fill: "#263238"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M154.43 110.022L152.641 110.095L144.512 98.6648C144.512 98.6648 148.757 101.364 154.43 110.022Z",
    fill: "#455A64"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M111.995 156.564C111.724 156.357 112.116 149.831 112.939 148.136C112.939 148.136 129.631 148.817 143.178 148.601C153.311 148.439 165.383 147.483 165.463 147.761C165.543 148.039 166.636 154.841 166.451 155.428C166.265 156.015 150.403 156.935 141.694 157.276C132.985 157.617 112.893 157.251 111.995 156.564Z",
    fill: "#514EFF"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M111.995 156.564C111.724 156.357 112.116 149.831 112.939 148.136C112.939 148.136 129.631 148.817 143.178 148.601C153.311 148.439 165.383 147.483 165.463 147.761C165.543 148.039 166.636 154.841 166.451 155.428C166.265 156.015 150.403 156.935 141.694 157.276C132.985 157.617 112.893 157.251 111.995 156.564Z",
    fill: "black"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M157.377 147.544C156.752 147.287 147.063 147.57 146.565 147.879C145.725 148.407 146.129 156.887 146.348 157.123C146.567 157.352 157.543 156.803 157.85 156.555C158.165 156.307 158.012 147.81 157.377 147.544ZM156.728 155.552C156.481 155.747 147.576 156.205 147.4 156.022C147.227 155.847 146.92 149.291 147.598 148.88C148.004 148.642 155.861 148.393 156.37 148.594C156.878 148.795 156.982 155.365 156.728 155.552Z",
    fill: "#DBDBDB"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M157.287 151.455L154.212 151.581L154.26 152.757L157.335 152.631L157.287 151.455Z",
    fill: "#DBDBDB"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M143.348 152.947C143.378 153.193 143.203 153.417 142.958 153.446C142.712 153.477 142.488 153.302 142.458 153.056C142.429 152.811 142.603 152.586 142.85 152.557C143.094 152.526 143.318 152.702 143.348 152.947Z",
    fill: "#263238"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M138.665 153.067C138.695 153.313 138.521 153.537 138.275 153.566C138.029 153.597 137.805 153.422 137.776 153.176C137.745 152.93 137.921 152.706 138.166 152.677C138.412 152.647 138.636 152.822 138.665 153.067Z",
    fill: "#263238"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M128.336 101.446C111.389 114.761 95.6149 138.486 95.4917 151.351C95.3701 164.055 99.7949 162.822 101.051 162.74C108.726 162.238 125.913 126.168 131.414 111.758C136.877 97.4515 132.527 98.1531 128.336 101.446Z",
    fill: "#D3766A"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M124.689 133.702L103.603 126.875C103.603 126.875 115.367 110.431 127.065 101.918C136.2 95.269 136.634 102.509 133.035 111.345C129.437 120.181 124.689 133.702 124.689 133.702Z",
    fill: "#EBEBEB"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M125.682 135.911L101.811 128.727L102.622 128.119L101.783 126.698L102.398 126.237L103.054 124.219L126.658 132.226L125.804 132.865L126.301 134.235L125.453 134.72L125.682 135.911Z",
    fill: "#DBDBDB"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M125.367 131.787C126.892 125.887 128.931 120.162 131.491 114.631C129.971 120.533 127.923 126.255 125.367 131.787Z",
    fill: "#263238"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M131.491 117.195C131.322 118.52 130.614 119.693 129.544 120.488C129.94 119.207 130.576 118.17 131.491 117.195Z",
    fill: "#263238"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M152.142 120.033L142.185 164.292L176.183 171.941L186.141 127.683L152.142 120.033Z",
    fill: "#514EFF"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M152.142 120.033L142.185 164.292L176.183 171.941L186.141 127.683L152.142 120.033Z",
    fill: "black"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M160.352 124.614L176.471 128.221L177.564 123.337L161.445 119.73L160.352 124.614Z",
    fill: "#DBDBDB"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M165.104 120.563L167.089 121.007L167.593 118.755L172.416 119.834L171.912 122.086L173.897 122.53L174.815 118.427L165.994 116.454L165.104 120.563Z",
    fill: "#DBDBDB"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M110.875 101.609C110.875 101.609 119.543 91.8232 131.607 98.2664C131.607 98.2664 134.195 132.901 134.651 134.985C135.107 137.068 146.892 175.23 146.892 175.23C146.892 175.23 138.506 181.938 124.641 177.702C124.641 177.702 124.445 137.828 124.139 136.679C123.833 135.53 110.875 101.609 110.875 101.609Z",
    fill: "#DBDBDB"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M146.891 175.23C146.891 175.23 133.752 168.803 124.641 177.702C124.641 177.702 134.953 182.943 146.891 175.23Z",
    fill: "#DBDBDB"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M134.651 134.985C135.153 134.548 133.961 134.468 133.695 134.434C131.168 134.222 128.607 134.562 126.159 135.168C125.461 135.38 124.679 135.55 124.142 136.051C123.98 136.21 123.944 136.474 124.139 136.68C124.034 136.606 123.922 136.511 123.886 136.362C123.879 135.389 125.225 134.916 125.963 134.576C128.659 133.622 131.834 133.194 134.52 134.365C134.779 134.484 135.081 134.83 134.651 134.985Z",
    fill: "#514EFF"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M134.783 135.518C135.254 135.043 134.046 135.051 133.777 135.036C131.217 135 128.674 135.551 126.242 136.307C125.545 136.561 124.774 136.778 124.229 137.286C124.057 137.447 124.024 137.714 124.238 137.906C124.122 137.848 124.008 137.749 123.968 137.598C123.976 136.65 125.297 136.11 126.015 135.73C128.669 134.61 131.814 133.919 134.603 134.905C134.871 135.006 135.205 135.331 134.783 135.518Z",
    fill: "#514EFF"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M134.906 135.931C135.402 135.498 134.04 135.853 133.857 135.891L132.375 136.235L129.408 136.934C128.035 137.29 125.561 137.648 124.29 138.228C124.05 138.35 123.997 138.577 124.215 138.765C124.105 138.707 123.978 138.62 123.957 138.452C124.572 136.702 133.207 135.097 134.996 135.611C135.217 135.708 135.059 135.873 134.906 135.931Z",
    fill: "#514EFF"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M149.804 178.201C149.804 178.201 142.637 189.134 129.771 184.496C129.771 184.496 122.218 150.596 121.467 148.6C120.715 146.604 103.554 110.539 103.554 110.539C103.554 110.539 110.885 102.693 125.215 104.886C125.215 104.886 131.157 144.314 131.624 145.407C132.092 146.502 149.804 178.201 149.804 178.201Z",
    fill: "#EBEBEB"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M103.554 110.54C103.554 110.54 117.482 115.006 125.215 104.886C125.215 104.886 114.255 101.186 103.554 110.54Z",
    fill: "#DBDBDB"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M121.466 148.601C121.033 149.105 122.225 149.013 122.493 149.008C125.023 148.854 127.508 148.148 129.844 147.196C130.503 146.885 131.252 146.605 131.712 146.031C131.849 145.851 131.847 145.584 131.624 145.409C131.9 145.506 132.04 145.854 131.903 146.122C130.302 148.722 124.51 150.087 121.685 149.197C121.412 149.114 121.063 148.814 121.466 148.601Z",
    fill: "#514EFF"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M121.258 148.092C121.019 148.366 121.325 148.46 121.565 148.465C123.343 148.423 125.101 147.87 126.766 147.284C128.367 146.606 130.208 146.078 131.447 144.822C131.594 144.636 131.588 144.369 131.348 144.209C131.646 144.279 131.774 144.65 131.635 144.916C129.997 147.555 124.505 149.356 121.525 148.674C121.245 148.611 120.868 148.338 121.258 148.092Z",
    fill: "#514EFF"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M121.078 147.701C120.649 148.201 121.946 147.653 122.121 147.589L123.538 147.035L126.373 145.916C127.681 145.366 130.077 144.655 131.251 143.898C131.47 143.742 131.49 143.51 131.249 143.357C131.366 143.397 131.505 143.465 131.548 143.629C131.193 145.449 122.878 148.283 121.034 148.032C120.802 147.965 120.933 147.78 121.078 147.701Z",
    fill: "#514EFF"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8139 162.675C103.785 165.53 112.001 164.094 134.044 158.559C137.094 157.793 137.479 134.814 134.18 135.465C130.024 136.284 114.075 140.365 112.946 140.81C103.427 144.569 95.4419 160.739 98.8139 162.675Z",
    fill: "#D3766A"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M125.669 139.018C125.669 139.018 133.266 134.18 138.045 132.873C144.443 131.123 150.688 132.247 153.277 132.876C158.68 134.189 170.837 141.099 169.457 144.947C168.209 148.431 156.139 140.74 156.139 140.74C156.139 140.74 169.739 146.551 167.464 150.47C165.189 154.388 151.686 144.662 151.686 144.662C151.686 144.662 165.525 150.946 162.541 154.616C160.285 157.389 147.559 149.27 147.559 149.27C147.559 149.27 159.417 154.754 157.22 157.705C154.792 160.966 142.575 154.209 142.575 154.209C135.728 160.772 129.782 161.096 125.526 160.823C124.496 160.758 125.669 139.018 125.669 139.018Z",
    fill: "#D3766A"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M151.565 138.429C153.186 139.054 154.833 139.675 156.394 140.442C157.956 141.209 159.491 142.031 160.974 142.939C164.61 145.168 166.539 147.133 166.406 147.024C163.277 144.461 157.73 141.63 156.169 140.863C154.611 140.097 153.091 139.254 151.534 138.487C151.494 138.468 151.526 138.415 151.565 138.429Z",
    fill: "#263238"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M148.693 144.016C150.73 144.903 152.785 145.71 154.783 146.688C156.771 147.661 158.573 148.759 160.489 149.866C160.637 149.951 160.543 150.003 160.391 149.923C158.432 148.893 156.541 148.092 154.571 147.085C152.607 146.082 150.667 144.995 148.669 144.063C148.637 144.048 148.662 144.003 148.693 144.016Z",
    fill: "#263238"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M145.367 148.368C148.549 149.565 151.507 151.347 154.366 153.165C154.508 153.255 154.379 153.308 154.228 153.224C151.267 151.573 148.955 150.257 145.324 148.479C145.267 148.451 145.299 148.343 145.367 148.368Z",
    fill: "#263238"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M102.373 150.559C104.415 147.038 107.168 143.762 110.697 141.63C115.577 139.302 121.143 138.35 126.379 137.151C127.71 136.888 129.034 136.598 130.37 136.358C129.077 136.774 127.772 137.139 126.474 137.532C121.386 139.054 115.875 140.13 111.042 142.302C107.591 144.274 104.743 147.378 102.373 150.559Z",
    fill: "#263238"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M136.495 110.75L138.757 110.658C138.757 110.658 136.057 100.746 134.16 98.3088L133.211 98.664C133.211 98.664 135.889 106.885 136.495 110.75Z",
    fill: "#455A64"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M135.357 98.7224C135.584 99.6648 142.331 107.069 146.418 105.45C147.932 104.851 145.711 98.72 145.711 98.72L147.564 90.1944L136.841 83.4768C136.841 83.4768 135.268 98.3216 135.357 98.7224Z",
    fill: "#D3766A"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M136.276 89.0239C138.694 94.9135 143.502 97.3759 145.814 98.2455L147.567 90.1967L136.843 83.4775C136.843 83.4775 136.587 85.9831 136.276 89.0239Z",
    fill: "#263238"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M158.238 76.7377C160.587 90.8337 152.409 93.8321 149.369 94.3353C146.61 94.7921 137.155 95.9961 133.362 82.2185C129.57 68.4409 135.381 62.8929 141.637 61.5145C147.894 60.1353 155.889 62.6417 158.238 76.7377Z",
    fill: "#D3766A"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M155.537 73.4002C155.2 73.4218 154.886 73.3858 154.551 73.373C154.172 73.3586 153.869 73.3858 153.549 73.1538C153.378 73.029 153.333 72.721 153.439 72.5426C153.684 72.1282 154.152 72.0306 154.608 72.0298C155.103 72.0282 155.486 72.1546 155.87 72.4658C156.242 72.7674 155.981 73.3714 155.537 73.4002Z",
    fill: "#263238"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M146.418 75.1899C146.741 75.0915 147.023 74.9467 147.332 74.8163C147.681 74.6691 147.974 74.5875 148.191 74.2571C148.307 74.0795 148.24 73.7755 148.079 73.6467C147.703 73.3451 147.23 73.4195 146.803 73.5795C146.339 73.7531 146.026 74.0059 145.777 74.4323C145.536 74.8467 145.993 75.3195 146.418 75.1899Z",
    fill: "#263238"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M149.078 78.3753C149.063 78.3401 149.012 78.4361 149.022 78.4745C149.249 79.4209 149.35 80.5441 148.553 81.0385C148.528 81.0537 148.541 81.1009 148.572 81.0897C149.594 80.7249 149.445 79.2361 149.078 78.3753Z",
    fill: "#263238"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M148.021 77.5561C146.465 77.7569 146.98 80.8561 148.422 80.6705C149.841 80.4873 149.326 77.3881 148.021 77.5561Z",
    fill: "#263238"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M147.44 77.8209C147.198 78.0409 146.984 78.3953 146.664 78.4817C146.292 78.5817 145.953 78.3049 145.655 78.0337C145.624 78.0057 145.601 78.0369 145.608 78.0785C145.697 78.6745 146.028 79.2449 146.679 79.2281C147.272 79.2121 147.602 78.6169 147.651 77.9953C147.66 77.8793 147.537 77.7321 147.44 77.8209Z",
    fill: "#263238"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M154.323 77.2433C154.325 77.2057 154.405 77.2769 154.41 77.3169C154.532 78.2825 154.834 79.3689 155.754 79.5505C155.783 79.5561 155.788 79.6049 155.755 79.6057C154.669 79.6241 154.283 78.1777 154.323 77.2433Z",
    fill: "#263238"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M155.022 76.1033C156.55 75.7409 157.162 78.8225 155.747 79.1585C154.354 79.4889 153.741 76.4073 155.022 76.1033Z",
    fill: "#263238"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M155.706 76.1786C155.982 76.2938 156.282 76.5426 156.576 76.5042C156.918 76.4594 157.101 76.077 157.253 75.7138C157.269 75.6762 157.299 75.697 157.308 75.7378C157.44 76.3234 157.368 76.9762 156.824 77.2018C156.328 77.4074 155.849 76.977 155.592 76.4186C155.544 76.3146 155.595 76.1322 155.706 76.1786Z",
    fill: "#263238"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M150.177 86.5538C150.426 86.7642 150.681 87.0602 151.035 87.0642C151.375 87.0674 151.76 86.8866 152.061 86.7434C152.09 86.729 152.124 86.7594 152.106 86.7898C151.882 87.181 151.369 87.453 150.914 87.4074C150.469 87.3626 150.223 86.9986 150.087 86.605C150.068 86.5498 150.141 86.5234 150.177 86.5538Z",
    fill: "#263238"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M153.746 82.3441C153.746 82.3441 154.134 83.7593 154.223 84.4393C154.231 84.5033 154.07 84.5545 153.841 84.5985C153.831 84.6033 153.825 84.6089 153.815 84.6025C152.639 84.9465 151.376 84.6905 150.518 83.8065C150.463 83.7465 150.54 83.6649 150.607 83.6993C151.589 84.2401 152.602 84.2801 153.669 84.1585C153.692 83.9641 152.924 81.7569 153.031 81.7345C153.399 81.6545 154.164 81.8113 154.62 81.8825C153.898 78.9113 152.705 76.0801 152.03 73.1105C152.008 73.0041 152.157 72.9521 152.202 73.0433C153.662 75.9225 154.568 79.3233 155.394 82.3729C155.5 82.7513 154.033 82.4249 153.746 82.3441Z",
    fill: "#263238"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M153.617 84.2827C153.617 84.2827 153.176 85.2739 152.38 85.7739C152.087 85.9587 151.753 86.0811 151.372 86.0651C150.589 86.0363 150.417 85.3635 150.423 84.7547C150.425 84.2539 150.554 83.7947 150.554 83.7947C150.554 83.7947 151.861 84.5611 153.617 84.2827Z",
    fill: "#263238"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M152.38 85.7739C152.087 85.9587 151.753 86.0811 151.372 86.0651C150.589 86.0363 150.417 85.3635 150.423 84.7547C151.233 84.6587 152.139 85.0203 152.38 85.7739Z",
    fill: "#FF9ABB"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M147.688 63.689C147.688 63.689 148.477 65.7874 147.899 67.421C146.709 70.7794 142.781 70.333 141.599 71.7346C140.492 73.0482 141.178 75.4634 140.187 76.7658C138.815 78.569 136.651 78.1482 136.511 79.281C136.371 80.4138 136.006 84.0138 134.648 84.6066C133.291 85.1994 124.411 62.4282 142.841 61.2714C142.841 61.2714 145.253 59.9786 149.365 61.553C153.903 63.2906 156.519 70.2226 156.519 70.2226C156.519 70.2226 156.418 70.1354 155.732 69.6434C154.765 68.9498 154.347 68.2586 153.645 67.8178C152.543 67.1242 152.014 67.4842 150.873 66.8162C149.135 65.7978 147.688 63.689 147.688 63.689Z",
    fill: "#263238"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M147.303 62.6978C147.683 63.5882 147.969 64.5186 148.132 65.4626C148.302 66.3954 148.356 67.3874 148.026 68.2442C147.688 69.0802 146.914 69.705 146.09 70.1074C145.25 70.5202 144.298 70.7114 143.398 71.1858C142.961 71.437 142.534 71.7602 142.265 72.241C142.002 72.7146 141.929 73.2314 141.872 73.7138C141.776 74.6794 141.674 75.6322 141.12 76.3714C140.577 77.1098 139.71 77.609 138.767 77.6634C137.842 77.7602 136.794 77.605 135.934 78.1066C136.831 77.677 137.81 77.9114 138.782 77.8866C139.778 77.877 140.761 77.3802 141.396 76.5874C142.072 75.7826 142.169 74.6978 142.282 73.7666C142.343 73.2938 142.425 72.8306 142.642 72.4578C142.85 72.0914 143.222 71.8042 143.618 71.5874C144.421 71.1442 145.384 70.9298 146.274 70.4818C146.718 70.2602 147.143 69.9777 147.507 69.6273C147.865 69.2866 148.206 68.865 148.356 68.3682C148.681 67.3874 148.568 66.3642 148.352 65.417C148.11 64.4666 147.75 63.557 147.303 62.6978Z",
    fill: "#263238"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M147.741 63.501C148.009 64.3626 148.403 65.1818 148.895 65.9514C149.379 66.721 150.079 67.4114 150.947 67.7938C151.382 67.9906 151.861 68.065 152.268 68.1578C152.656 68.253 153.079 68.449 153.328 68.7234C153.602 69.0394 153.872 69.4442 154.24 69.7298C154.608 70.0138 155.036 70.2042 155.476 70.2922C155.068 70.105 154.683 69.881 154.389 69.5618C154.073 69.2602 153.874 68.8874 153.6 68.4994C153.278 68.0754 152.832 67.8946 152.378 67.7442C151.92 67.6202 151.509 67.5594 151.129 67.3786C150.356 67.0322 149.72 66.4402 149.193 65.7378C148.655 65.0426 148.192 64.2786 147.741 63.501Z",
    fill: "#263238"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M136.231 82.7161C136.231 82.7161 132.558 78.7001 130.696 80.0665C128.835 81.4329 132.002 87.5377 134.473 88.1049C136.944 88.6721 137.514 86.3953 137.514 86.3953L136.231 82.7161Z",
    fill: "#D3766A"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M131.648 81.7937C131.609 81.7953 131.609 81.8489 131.644 81.8585C133.384 82.3105 134.454 83.7281 135.273 85.2361C134.701 84.6897 133.988 84.4425 133.246 85.1345C133.208 85.1705 133.257 85.2329 133.303 85.2169C133.961 84.9825 134.465 85.0361 134.993 85.5177C135.367 85.8585 135.652 86.3153 135.942 86.7273C136.039 86.8649 136.295 86.7505 136.217 86.5881C136.211 86.5761 136.204 86.5641 136.198 86.5513C135.961 84.4401 133.937 81.7081 131.648 81.7937Z",
    fill: "#263238"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M156.456 68.8521L152.24 70.5177C150.028 71.0609 147.343 71.8353 144.453 72.9145C141.356 74.0729 138.325 75.6113 135.879 76.9913L131.34 78.7849C131.34 78.7849 131.133 78.2625 130.908 77.3873C130.014 73.9313 128.805 64.9689 138.741 61.0385C148.7 57.1017 154.061 64.4641 155.807 67.5665C156.245 68.3449 156.456 68.8521 156.456 68.8521Z",
    fill: "#514EFF"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.102 69.7368L148.982 70.5768L143.381 59.9416C143.959 59.9 144.515 59.9 145.052 59.9376C149.445 64.1296 151.102 69.7368 151.102 69.7368Z",
    fill: "black"
  }))), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M144.281 72.1689L150.446 70.0849C150.446 70.0849 147.658 62.5713 143.097 59.4113C142.713 59.1457 138.007 60.5593 136.749 61.1633C136.114 61.4681 136.205 62.2945 136.205 62.2945C138.588 61.0425 143.542 69.9689 144.281 72.1689Z",
    fill: "#514EFF"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M145.267 71.8353L144.281 72.1689C143.542 69.9681 138.587 61.0441 136.204 62.2953C136.204 62.2953 136.151 61.7857 136.432 61.4209C136.971 61.0641 138.845 61.6289 140.527 63.8017C142.207 65.9745 144.035 68.7353 145.267 71.8353Z",
    fill: "white"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M130.368 79.3863C130.484 79.7711 130.952 79.8943 131.287 79.6727C133.152 78.4399 147.843 70.6031 157.155 69.6327C157.557 69.5903 157.678 68.1111 156.855 68.1087C154.28 68.1007 148.821 69.4455 143.544 71.4983C137.094 74.0071 132.803 76.6831 130.871 78.0119C130.175 78.4903 130.261 79.0359 130.368 79.3863Z",
    fill: "#514EFF"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M130.871 78.012C133.01 76.2008 135.208 74.9728 139.598 72.8376C139.598 72.8376 140.615 71.6952 141.146 71.2664C141.677 70.8384 150.642 67.3672 153.929 67.3064C154.115 67.3032 154.805 68.232 154.805 68.232C156.413 67.9984 156.855 68.1096 156.855 68.1096C156.855 68.1096 155.225 68.1712 150.275 69.5352C145.325 70.8992 137.982 74.1072 134.72 75.824C131.457 77.5392 130.871 78.012 130.871 78.012Z",
    fill: "#514EFF"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M154.373 67.6904C154.273 67.6096 154.148 67.5472 154.005 67.5576C152.767 67.6392 150.805 68.0792 149.057 68.6472C145.855 69.6832 142.444 70.908 141.493 71.4368C141.073 71.6704 139.676 73.0944 139.676 73.0944C138.743 73.4552 134.378 75.6216 131.366 77.604C133.361 76.0048 135.548 74.8064 139.6 72.8376C139.6 72.8376 140.616 71.6936 141.145 71.2648C141.677 70.8352 150.641 67.3664 153.929 67.304C154.013 67.3024 154.195 67.4872 154.373 67.6904Z",
    fill: "white"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M131.149 71.9328C131.149 71.9328 131.59 65.8912 136.144 63.136L137.929 65.5552L135.446 66.9592L134.258 66.5232L134.419 67.7896L133.773 68.2216L133.257 68.9096L133.186 69.2688C133.186 69.2688 131.939 69.9296 131.149 71.9328Z",
    fill: "white"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M145.853 98.1425L143.598 104.544L135.436 96.9209L133.331 99.5713C133.331 99.5713 141.525 111.889 141.549 111.315L143.907 105.78L147.813 109.391L147.101 99.9321L145.853 98.1425Z",
    fill: "#EBEBEB"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M147.726 104.695C147.556 103.138 147.428 101.564 147.186 100.015C147.177 99.9602 147.09 99.9394 147.079 100.005C146.831 101.527 147.513 107.481 147.568 108.913C147.563 108.908 147.556 108.903 147.551 108.897C147.388 108.741 143.939 105.727 143.908 105.779C143.383 106.664 141.651 110.695 141.536 111.061C140.24 109.104 135.289 102.001 133.775 100.163C133.732 100.111 133.649 100.159 133.684 100.222C134.844 102.297 141.403 111.867 141.497 111.835C141.563 111.883 143.718 106.915 143.961 105.984C144.551 106.648 148.05 110.066 148.051 109.833C148.059 108.263 147.895 106.255 147.726 104.695Z",
    fill: "#263238"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M523.267 312.032V217.935L521.637 215.779L524.194 110.78L482.227 30.7071L476.719 28.8071L285.382 96.4335",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M518.955 312.032V217.935L520.585 215.779L518.028 110.78L479.145 33.1638",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M454.175 367.091H530.587V361.074H454.175V367.091Z",
    fill: "#C7C7C7"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M449.651 375.387H535.112V367.092H449.651V375.387Z",
    fill: "#A6A6A6"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M480.353 361.074H481.069V129.774H480.353V361.074Z",
    fill: "#514EFF"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M477.22 361.074H477.936V129.774H477.22V361.074Z",
    fill: "#514EFF"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 359.771V359.055H477.936V359.771H480.354Z",
    fill: "#514EFF"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 357.402V356.686H477.936V357.402H480.354Z",
    fill: "#514EFF"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 355.033V354.317H477.936V355.033H480.354Z",
    fill: "#514EFF"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 352.664V351.948H477.936V352.664H480.354Z",
    fill: "#514EFF"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 350.295V349.579H477.936V350.295H480.354Z",
    fill: "#514EFF"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 347.925V347.209H477.936V347.925H480.354Z",
    fill: "#514EFF"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 345.557V344.841H477.936V345.557H480.354Z",
    fill: "#514EFF"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 343.187V342.471H477.936V343.187H480.354Z",
    fill: "#514EFF"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 340.818V340.102H477.936V340.818H480.354Z",
    fill: "#514EFF"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 338.449V337.733H477.936V338.449H480.354Z",
    fill: "#514EFF"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 336.08V335.364H477.936V336.08H480.354Z",
    fill: "#514EFF"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 333.711V332.995H477.936V333.711H480.354Z",
    fill: "#514EFF"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 331.342V330.626H477.936V331.342H480.354Z",
    fill: "#514EFF"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 328.973V328.257H477.936V328.973H480.354Z",
    fill: "#514EFF"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 326.604V325.888H477.936V326.604H480.354Z",
    fill: "#514EFF"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 324.235V323.519H477.936V324.235H480.354Z",
    fill: "#514EFF"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 321.866V321.15H477.936V321.866H480.354Z",
    fill: "#514EFF"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 319.497V318.781H477.936V319.497H480.354Z",
    fill: "#514EFF"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 317.128V316.412H477.936V317.128H480.354Z",
    fill: "#514EFF"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 314.758V314.042H477.936V314.758H480.354Z",
    fill: "#514EFF"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 312.39V311.674H477.936V312.39H480.354Z",
    fill: "#514EFF"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 310.02V309.304H477.936V310.02H480.354Z",
    fill: "#514EFF"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 307.651V306.935H477.936V307.651H480.354Z",
    fill: "#514EFF"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 305.282V304.566H477.936V305.282H480.354Z",
    fill: "#514EFF"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 302.913V302.197H477.936V302.913H480.354Z",
    fill: "#514EFF"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 300.544V299.828H477.936V300.544H480.354Z",
    fill: "#514EFF"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 298.175V297.459H477.936V298.175H480.354Z",
    fill: "#514EFF"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 295.806V295.09H477.936V295.806H480.354Z",
    fill: "#514EFF"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 293.437V292.721H477.936V293.437H480.354Z",
    fill: "#514EFF"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 291.068V290.352H477.936V291.068H480.354Z",
    fill: "#514EFF"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 288.699V287.983H477.936V288.699H480.354Z",
    fill: "#514EFF"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 286.33V285.614H477.936V286.33H480.354Z",
    fill: "#514EFF"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 283.961V283.245H477.936V283.961H480.354Z",
    fill: "#514EFF"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 281.592V280.875H477.936V281.592H480.354Z",
    fill: "#514EFF"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 279.222V278.506H477.936V279.222H480.354Z",
    fill: "#514EFF"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 276.853V276.137H477.936V276.853H480.354Z",
    fill: "#514EFF"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 274.484V273.768H477.936V274.484H480.354Z",
    fill: "#514EFF"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 272.115V271.399H477.936V272.115H480.354Z",
    fill: "#514EFF"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 269.746V269.03H477.936V269.746H480.354Z",
    fill: "#514EFF"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 267.377V266.661H477.936V267.377H480.354Z",
    fill: "#514EFF"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 265.008V264.292H477.936V265.008H480.354Z",
    fill: "#514EFF"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 262.639V261.923H477.936V262.639H480.354Z",
    fill: "#514EFF"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 260.27V259.554H477.936V260.27H480.354Z",
    fill: "#514EFF"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 257.901V257.185H477.936V257.901H480.354Z",
    fill: "#514EFF"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 255.532V254.816H477.936V255.532H480.354Z",
    fill: "#514EFF"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 253.163V252.447H477.936V253.163H480.354Z",
    fill: "#514EFF"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 250.794V250.078H477.936V250.794H480.354Z",
    fill: "#514EFF"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 248.425V247.708H477.936V248.425H480.354Z",
    fill: "#514EFF"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 246.055V245.339H477.936V246.055H480.354Z",
    fill: "#514EFF"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 243.686V242.97H477.936V243.686H480.354Z",
    fill: "#514EFF"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 241.317V240.601H477.936V241.317H480.354Z",
    fill: "#514EFF"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 238.948V238.232H477.936V238.948H480.354Z",
    fill: "#514EFF"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 236.579V235.863H477.936V236.579H480.354Z",
    fill: "#514EFF"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 234.21V233.494H477.936V234.21H480.354Z",
    fill: "#514EFF"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 231.841V231.125H477.936V231.841H480.354Z",
    fill: "#514EFF"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 229.472V228.756H477.936V229.472H480.354Z",
    fill: "#514EFF"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 227.103V226.387H477.936V227.103H480.354Z",
    fill: "#514EFF"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 224.734V224.018H477.936V224.734H480.354Z",
    fill: "#514EFF"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 222.365V221.649H477.936V222.365H480.354Z",
    fill: "#514EFF"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 219.996V219.28H477.936V219.996H480.354Z",
    fill: "#514EFF"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 217.627V216.911H477.936V217.627H480.354Z",
    fill: "#514EFF"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 215.258V214.542H477.936V215.258H480.354Z",
    fill: "#514EFF"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 212.888V212.172H477.936V212.888H480.354Z",
    fill: "#514EFF"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 210.519V209.803H477.936V210.519H480.354Z",
    fill: "#514EFF"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 208.15V207.434H477.936V208.15H480.354Z",
    fill: "#514EFF"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 205.781V205.065H477.936V205.781H480.354Z",
    fill: "#514EFF"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 203.412V202.696H477.936V203.412H480.354Z",
    fill: "#514EFF"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 201.043V200.327H477.936V201.043H480.354Z",
    fill: "#514EFF"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 198.674V197.958H477.936V198.674H480.354Z",
    fill: "#514EFF"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 196.305V195.589H477.936V196.305H480.354Z",
    fill: "#514EFF"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 193.936V193.22H477.937V193.936H480.354Z",
    fill: "#514EFF"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 191.567V190.851H477.936V191.567H480.354Z",
    fill: "#514EFF"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 189.198V188.482H477.936V189.198H480.354Z",
    fill: "#514EFF"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 186.829V186.113H477.936V186.829H480.354Z",
    fill: "#514EFF"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 184.459V183.743H477.936V184.459H480.354Z",
    fill: "#514EFF"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 182.091V181.375H477.936V182.091H480.354Z",
    fill: "#514EFF"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 179.721V179.005H477.936V179.721H480.354Z",
    fill: "#514EFF"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 177.352V176.636H477.936V177.352H480.354Z",
    fill: "#514EFF"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 174.983V174.267H477.936V174.983H480.354Z",
    fill: "#514EFF"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 172.614V171.898H477.936V172.614H480.354Z",
    fill: "#514EFF"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 170.245V169.529H477.936V170.245H480.354Z",
    fill: "#514EFF"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 167.876V167.16H477.936V167.876H480.354Z",
    fill: "#514EFF"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 165.507V164.791H477.936V165.507H480.354Z",
    fill: "#514EFF"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 163.138V162.422H477.936V163.138H480.354Z",
    fill: "#514EFF"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 160.769V160.053H477.936V160.769H480.354Z",
    fill: "#514EFF"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 158.4V157.684H477.936V158.4H480.354Z",
    fill: "#514EFF"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 156.031V155.315H477.936V156.031H480.354Z",
    fill: "#514EFF"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 153.662V152.946H477.936V153.662H480.354Z",
    fill: "#514EFF"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 151.292V150.576H477.936V151.292H480.354Z",
    fill: "#514EFF"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 148.923V148.207H477.936V148.923H480.354Z",
    fill: "#514EFF"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 146.554V145.838H477.936V146.554H480.354Z",
    fill: "#514EFF"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 144.185V143.469H477.936V144.185H480.354Z",
    fill: "#514EFF"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 141.816V141.1H477.936V141.816H480.354Z",
    fill: "#514EFF"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 139.447V138.731H477.936V139.447H480.354Z",
    fill: "#514EFF"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 137.078V136.362H477.936V137.078H480.354Z",
    fill: "#514EFF"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 134.709V133.993H477.936V134.709H480.354Z",
    fill: "#514EFF"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M480.354 132.34V131.624H477.936V132.34H480.354Z",
    fill: "#514EFF"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480.353 361.074H481.069V129.774H480.353V361.074Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.22 361.074H477.936V129.774H477.22V361.074Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 359.771V359.055H477.936V359.771H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 357.402V356.686H477.936V357.402H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 355.033V354.317H477.936V355.033H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 352.664V351.948H477.936V352.664H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 350.295V349.579H477.936V350.295H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 347.925V347.209H477.936V347.925H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 345.557V344.841H477.936V345.557H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 343.187V342.471H477.936V343.187H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 340.818V340.102H477.936V340.818H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 338.449V337.733H477.936V338.449H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 336.08V335.364H477.936V336.08H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 333.711V332.995H477.936V333.711H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 331.342V330.626H477.936V331.342H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 328.973V328.257H477.936V328.973H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 326.604V325.888H477.936V326.604H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 324.235V323.519H477.936V324.235H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 321.866V321.15H477.936V321.866H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 319.497V318.781H477.936V319.497H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 317.128V316.412H477.936V317.128H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 314.758V314.042H477.936V314.758H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 312.39V311.674H477.936V312.39H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 310.02V309.304H477.936V310.02H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 307.651V306.935H477.936V307.651H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 305.282V304.566H477.936V305.282H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 302.913V302.197H477.936V302.913H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 300.544V299.828H477.936V300.544H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 298.175V297.459H477.936V298.175H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 295.806V295.09H477.936V295.806H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 293.437V292.721H477.936V293.437H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 291.068V290.352H477.936V291.068H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 288.699V287.983H477.936V288.699H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 286.33V285.614H477.936V286.33H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 283.961V283.245H477.936V283.961H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 281.592V280.875H477.936V281.592H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 279.222V278.506H477.936V279.222H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 276.853V276.137H477.936V276.853H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 274.484V273.768H477.936V274.484H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 272.115V271.399H477.936V272.115H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 269.746V269.03H477.936V269.746H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 267.377V266.661H477.936V267.377H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 265.008V264.292H477.936V265.008H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 262.639V261.923H477.936V262.639H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 260.27V259.554H477.936V260.27H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 257.901V257.185H477.936V257.901H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 255.532V254.816H477.936V255.532H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 253.163V252.447H477.936V253.163H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 250.794V250.078H477.936V250.794H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 248.425V247.708H477.936V248.425H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 246.055V245.339H477.936V246.055H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 243.686V242.97H477.936V243.686H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 241.317V240.601H477.936V241.317H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 238.948V238.232H477.936V238.948H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 236.579V235.863H477.936V236.579H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 234.21V233.494H477.936V234.21H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 231.841V231.125H477.936V231.841H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 229.472V228.756H477.936V229.472H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 227.103V226.387H477.936V227.103H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 224.734V224.018H477.936V224.734H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 222.365V221.649H477.936V222.365H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 219.996V219.28H477.936V219.996H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 217.627V216.911H477.936V217.627H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 215.258V214.542H477.936V215.258H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 212.888V212.172H477.936V212.888H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 210.519V209.803H477.936V210.519H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 208.15V207.434H477.936V208.15H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 205.781V205.065H477.936V205.781H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 203.412V202.696H477.936V203.412H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 201.043V200.327H477.936V201.043H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 198.674V197.958H477.936V198.674H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 196.305V195.589H477.936V196.305H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 193.936V193.22H477.937V193.936H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 191.567V190.851H477.936V191.567H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 189.198V188.482H477.936V189.198H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 186.829V186.113H477.936V186.829H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 184.459V183.743H477.936V184.459H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 182.091V181.375H477.936V182.091H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 179.721V179.005H477.936V179.721H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 177.352V176.636H477.936V177.352H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 174.983V174.267H477.936V174.983H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 172.614V171.898H477.936V172.614H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 170.245V169.529H477.936V170.245H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 167.876V167.16H477.936V167.876H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 165.507V164.791H477.936V165.507H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 163.138V162.422H477.936V163.138H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 160.769V160.053H477.936V160.769H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 158.4V157.684H477.936V158.4H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 156.031V155.315H477.936V156.031H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 153.662V152.946H477.936V153.662H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 151.292V150.576H477.936V151.292H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 148.923V148.207H477.936V148.923H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 146.554V145.838H477.936V146.554H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 144.185V143.469H477.936V144.185H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 141.816V141.1H477.936V141.816H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 139.447V138.731H477.936V139.447H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 137.078V136.362H477.936V137.078H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 134.709V133.993H477.936V134.709H480.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.354 132.34V131.624H477.936V132.34H480.354Z",
    fill: "black"
  }))), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M471.627 275.187V303.612L476.738 356.562H481.551L486.662 303.612V275.187H471.627Z",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M486.662 303.612H471.627",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M486.662 275.187L479.145 300.907L471.627 275.187",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M474.182 330.086L479.144 304.367L484.138 330.086",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M479.145 303.612V356.562",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M468.369 303.612V274.563H472.251L472.248 303.562L476.603 357.186H474.526L468.369 303.612ZM469.617 275.812L469.613 303.541L474.313 344.41L471.002 303.613V275.813L469.617 275.812Z",
    fill: "#514EFF"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M471.627 302.988H468.993V304.237H471.627V302.988Z",
    fill: "#514EFF"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M469.686 300.938H470.933L472.25 275.219L471.003 275.156L470.31 288.698L469.616 275.156L468.369 275.219L469.686 300.938Z",
    fill: "#514EFF"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M470.911 303.56L469.668 303.681L474.861 356.629L476.103 356.507L470.911 303.56Z",
    fill: "#514EFF"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M468.369 303.612V274.563H472.251L472.248 303.562L476.603 357.186H474.526L468.369 303.612ZM469.617 275.812L469.613 303.541L474.313 344.41L471.002 303.613V275.813L469.617 275.812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.627 302.988H468.993V304.237H471.627V302.988Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.686 300.938H470.933L472.25 275.219L471.003 275.156L470.31 288.698L469.616 275.156L468.369 275.219L469.686 300.938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.911 303.56L469.668 303.681L474.861 356.629L476.103 356.507L470.911 303.56Z",
    fill: "black"
  }))), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M486.662 107.562V81.5745L480.334 33.1641H477.955L471.627 81.5745V107.562H486.662Z",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M471.627 81.5745H486.662",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M471.627 107.563L479.145 84.0474L486.662 107.563",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M483.498 57.3696L479.145 80.884L474.782 57.4368",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M479.145 81.5745V33.1641",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M473.127 275.188H485.16V129.774H473.127V275.188Z",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M473.127 275.187L485.161 267.534L473.127 259.881",
    stroke: "#514EFF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M473.127 259.881L485.161 252.227L473.127 244.574",
    stroke: "#514EFF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M484.973 259.881H473.127",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M473.127 244.575L485.161 236.921L473.127 229.267",
    stroke: "#514EFF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M484.973 244.574H473.127",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M473.127 229.267L485.161 221.614L473.127 213.961",
    stroke: "#514EFF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M484.973 229.267H473.127",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M473.127 213.961L485.161 206.307L473.127 198.654",
    stroke: "#514EFF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M484.973 213.961H473.127",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M473.127 198.654L485.161 191.001L473.127 183.347",
    stroke: "#514EFF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M484.973 198.654H473.127",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M473.127 183.347L485.161 175.694L473.127 168.041",
    stroke: "#514EFF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M484.973 183.347H473.127",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M473.127 168.041L485.161 160.387L473.127 152.734",
    stroke: "#514EFF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M484.973 168.041H473.127",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M473.127 152.734L485.161 145.08L473.127 137.427",
    stroke: "#514EFF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M484.973 152.734H473.127",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M473.127 137.427L485.161 129.774",
    stroke: "#514EFF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M484.973 137.427H473.127",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M469.504 129.15H473.752V275.812H469.504V129.15ZM472.504 130.398H470.753V274.563H472.504V130.398Z",
    fill: "#514EFF"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M472.838 275.302L473.419 275.074L470.464 267.535L473.419 259.995L472.838 259.767L469.793 267.535L472.838 275.302Z",
    fill: "#514EFF"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M472.838 259.994L473.419 259.767L470.464 252.228L473.419 244.688L472.838 244.461L469.793 252.228L472.838 259.994Z",
    fill: "#514EFF"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M473.129 259.257H470.176V260.506H473.129V259.257Z",
    fill: "#514EFF"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M472.838 244.688L473.419 244.461L470.464 236.921L473.419 229.382L472.838 229.154L469.793 236.921L472.838 244.688Z",
    fill: "#514EFF"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M473.129 243.95H470.176V245.199H473.129V243.95Z",
    fill: "#514EFF"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M472.838 229.382L473.419 229.154L470.464 221.614L473.419 214.075L472.838 213.847L469.793 221.614L472.838 229.382Z",
    fill: "#514EFF"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M473.129 228.643H470.176V229.892H473.129V228.643Z",
    fill: "#514EFF"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M472.838 214.075L473.419 213.847L470.464 206.308L473.419 198.767L472.838 198.54L469.793 206.308L472.838 214.075Z",
    fill: "#514EFF"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M473.129 213.337H470.176V214.586H473.129V213.337Z",
    fill: "#514EFF"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M472.838 198.767L473.419 198.54L470.464 191.001L473.419 183.461L472.838 183.234L469.793 191.001L472.838 198.767Z",
    fill: "#514EFF"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M473.129 198.03H470.176V199.278H473.129V198.03Z",
    fill: "#514EFF"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M472.838 183.461L473.419 183.234L470.464 175.694L473.419 168.155L472.838 167.927L469.793 175.694L472.838 183.461Z",
    fill: "#514EFF"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M473.129 182.723H470.176V183.972H473.129V182.723Z",
    fill: "#514EFF"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M472.838 168.155L473.419 167.927L470.464 160.387L473.419 152.848L472.838 152.62L469.793 160.387L472.838 168.155Z",
    fill: "#514EFF"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M473.129 167.416H470.176V168.665H473.129V167.416Z",
    fill: "#514EFF"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M472.838 152.848L473.419 152.62L470.464 145.08L473.419 137.541L472.838 137.313L469.793 145.08L472.838 152.848Z",
    fill: "#514EFF"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M473.129 152.11H470.176V153.358H473.129V152.11Z",
    fill: "#514EFF"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M470.407 129.652L469.826 129.879L472.824 137.533L473.405 137.305L470.407 129.652Z",
    fill: "#514EFF"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M473.129 136.802H470.176V138.051H473.129V136.802Z",
    fill: "#514EFF"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M469.504 129.15H473.752V275.812H469.504V129.15ZM472.504 130.398H470.753V274.563H472.504V130.398Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.838 275.302L473.419 275.074L470.464 267.535L473.419 259.995L472.838 259.767L469.793 267.535L472.838 275.302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.838 259.994L473.419 259.767L470.464 252.228L473.419 244.688L472.838 244.461L469.793 252.228L472.838 259.994Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.129 259.257H470.176V260.506H473.129V259.257Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.838 244.688L473.419 244.461L470.464 236.921L473.419 229.382L472.838 229.154L469.793 236.921L472.838 244.688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.129 243.95H470.176V245.199H473.129V243.95Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.838 229.382L473.419 229.154L470.464 221.614L473.419 214.075L472.838 213.847L469.793 221.614L472.838 229.382Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.129 228.643H470.176V229.892H473.129V228.643Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.838 214.075L473.419 213.847L470.464 206.308L473.419 198.767L472.838 198.54L469.793 206.308L472.838 214.075Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.129 213.337H470.176V214.586H473.129V213.337Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.838 198.767L473.419 198.54L470.464 191.001L473.419 183.461L472.838 183.234L469.793 191.001L472.838 198.767Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.129 198.03H470.176V199.278H473.129V198.03Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.838 183.461L473.419 183.234L470.464 175.694L473.419 168.155L472.838 167.927L469.793 175.694L472.838 183.461Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.129 182.723H470.176V183.972H473.129V182.723Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.838 168.155L473.419 167.927L470.464 160.387L473.419 152.848L472.838 152.62L469.793 160.387L472.838 168.155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.129 167.416H470.176V168.665H473.129V167.416Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.838 152.848L473.419 152.62L470.464 145.08L473.419 137.541L472.838 137.313L469.793 145.08L472.838 152.848Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.129 152.11H470.176V153.358H473.129V152.11Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.407 129.652L469.826 129.879L472.824 137.533L473.405 137.305L470.407 129.652Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.129 136.802H470.176V138.051H473.129V136.802Z",
    fill: "black"
  }))), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M234.117 107.562H471.492V97.5432H240.818L234.528 106.942L234.117 107.562Z",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M394.84 97.5432L402.493 107.562L410.146 97.5432",
    stroke: "#514EFF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M410.146 97.5432L417.8 107.562L425.454 97.5432",
    stroke: "#514EFF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M410.146 107.406V97.5432",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M379.533 97.5432L387.187 107.562L394.84 97.5432",
    stroke: "#514EFF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M394.84 107.406V97.5432",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M364.227 97.5432L371.88 107.562L379.533 97.5432",
    stroke: "#514EFF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M379.533 107.406V97.5432",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M348.92 97.5432L356.573 107.562L364.226 97.5432",
    stroke: "#514EFF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M364.227 107.406V97.5432",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M333.612 97.5432L341.266 107.562L348.92 97.5432",
    stroke: "#514EFF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M348.92 107.406V97.5432",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M318.307 97.5432L325.959 107.562L333.613 97.5432",
    stroke: "#514EFF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M333.612 107.406V97.5432",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M302.999 97.5432L310.653 107.562L318.306 97.5432",
    stroke: "#514EFF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M318.307 107.406V97.5432",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M287.692 97.5432L295.346 107.562L302.999 97.5432",
    stroke: "#514EFF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M302.999 107.406V97.5432",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M272.387 97.5432L280.04 107.562L287.693 97.5432",
    stroke: "#514EFF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M287.692 107.406V97.5432",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M257.079 97.5432L264.733 107.562L272.386 97.5432",
    stroke: "#514EFF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M272.387 107.406V97.5432",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M241.772 97.5432L249.426 107.562L257.079 97.5432",
    stroke: "#514EFF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M257.079 107.406V97.5432",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M234.119 107.562L241.773 97.5432",
    stroke: "#514EFF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M241.772 107.406V97.5432",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M425.453 97.5432L433.106 107.562L440.76 97.5432",
    stroke: "#514EFF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M425.453 107.406V97.5432",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M440.76 97.5432L448.413 107.562L456.066 97.5432",
    stroke: "#514EFF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M440.76 107.406V97.5432",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M456.066 97.5432L463.72 107.562L471.374 97.5432",
    stroke: "#514EFF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M456.066 107.406V97.5432",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M471.37 97.5432L471.491 97.704",
    stroke: "#514EFF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M471.373 107.406V97.5432",
    stroke: "#514EFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M234.528 106.942L234.568 106.974L235.414 107.562L240.915 111.404H471.492V110.156H241.309L241.148 110.043L240.972 109.922L240.964 109.914L238.491 108.191H471.492V106.943H234.528V106.942ZM463.028 108.19H464.413L463.72 107.901L463.028 108.19ZM447.724 108.19H449.11L448.417 107.901L447.724 108.19ZM432.414 108.19H433.8L433.107 107.901L432.414 108.19ZM417.111 108.19H418.497L417.804 107.901L417.111 108.19ZM401.801 108.19H403.187L402.494 107.901L401.801 108.19ZM386.498 108.19H387.884L387.191 107.901L386.498 108.19ZM371.188 108.19H372.573L371.88 107.901L371.188 108.19ZM355.877 108.19H357.263L356.57 107.901L355.877 108.19ZM340.575 108.19H341.96L341.268 107.901L340.575 108.19ZM325.264 108.19H326.65L325.957 107.901L325.264 108.19ZM309.961 108.19H311.347L310.654 107.901L309.961 108.19ZM294.651 108.19H296.036L295.344 107.901L294.651 108.19ZM279.348 108.19H280.734L280.041 107.901L279.348 108.19ZM264.038 108.19H265.424L264.731 107.901L264.038 108.19ZM248.736 108.19H250.121L249.428 107.901L248.736 108.19Z",
    fill: "#514EFF"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M394.962 111.068L402.493 107.901L410.026 111.068L410.268 110.492L402.493 107.224L394.72 110.492L394.962 111.068Z",
    fill: "#514EFF"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M410.268 111.068L417.801 107.901L425.333 111.068L425.575 110.492L417.801 107.224L410.026 110.492L410.268 111.068Z",
    fill: "#514EFF"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M410.771 107.613H409.523V110.78H410.771V107.613Z",
    fill: "#514EFF"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M379.655 111.068L387.187 107.901L394.719 111.068L394.962 110.492L387.187 107.224L379.413 110.492L379.655 111.068Z",
    fill: "#514EFF"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M395.466 107.613H394.217V110.78H395.466V107.613Z",
    fill: "#514EFF"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M379.413 111.068L379.655 110.492L371.88 107.224L364.105 110.492L364.348 111.068L371.88 107.901L379.413 111.068Z",
    fill: "#514EFF"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M380.159 107.613H378.91V110.78H380.159V107.613Z",
    fill: "#514EFF"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M349.041 111.068L356.573 107.901L364.105 111.068L364.348 110.492L356.573 107.224L348.799 110.492L349.041 111.068Z",
    fill: "#514EFF"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M364.851 107.613H363.603V110.78H364.851V107.613Z",
    fill: "#514EFF"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M333.734 111.068L341.267 107.901L348.799 111.068L349.041 110.492L341.267 107.224L333.492 110.492L333.734 111.068Z",
    fill: "#514EFF"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M349.545 107.613H348.296V110.78H349.545V107.613Z",
    fill: "#514EFF"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M318.428 111.068L325.96 107.901L333.493 111.068L333.734 110.492L325.96 107.224L318.186 110.492L318.428 111.068Z",
    fill: "#514EFF"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M334.238 107.613H332.989V110.78H334.238V107.613Z",
    fill: "#514EFF"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M303.121 111.068L310.653 107.901L318.185 111.068L318.428 110.492L310.653 107.224L302.879 110.492L303.121 111.068Z",
    fill: "#514EFF"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M318.93 107.613H317.682V110.78H318.93V107.613Z",
    fill: "#514EFF"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M287.814 111.068L295.347 107.901L302.879 111.068L303.121 110.492L295.347 107.224L287.572 110.492L287.814 111.068Z",
    fill: "#514EFF"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M303.624 107.613H302.376V110.78H303.624V107.613Z",
    fill: "#514EFF"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M272.508 111.068L280.04 107.901L287.573 111.068L287.814 110.492L280.04 107.224L272.266 110.492L272.508 111.068Z",
    fill: "#514EFF"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M288.318 107.613H287.069V110.78H288.318V107.613Z",
    fill: "#514EFF"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M257.201 111.068L264.733 107.901L272.265 111.068L272.508 110.492L264.733 107.224L256.959 110.492L257.201 111.068Z",
    fill: "#514EFF"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M273.011 107.613H271.762V110.78H273.011V107.613Z",
    fill: "#514EFF"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M241.894 111.068L249.427 107.901L256.959 111.068L257.201 110.492L249.427 107.224L241.652 110.492L241.894 111.068Z",
    fill: "#514EFF"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M257.704 107.613H256.456V110.78H257.704V107.613Z",
    fill: "#514EFF"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M236.665 107.298L236.34 107.831L241.602 111.044L241.927 110.512L236.665 107.298Z",
    fill: "#514EFF"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M242.398 107.613H241.149V110.78H242.398V107.613Z",
    fill: "#514EFF"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M425.574 111.068L433.107 107.901L440.639 111.068L440.882 110.492L433.107 107.224L425.332 110.492L425.574 111.068Z",
    fill: "#514EFF"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M426.078 107.613H424.829V110.78H426.078V107.613Z",
    fill: "#514EFF"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M440.882 111.068L448.414 107.901L455.946 111.068L456.188 110.492L448.414 107.224L440.64 110.492L440.882 111.068Z",
    fill: "#514EFF"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M441.386 107.613H440.137V110.78H441.386V107.613Z",
    fill: "#514EFF"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M456.189 111.068L463.721 107.901L471.253 111.068L471.495 110.492L463.721 107.224L455.946 110.492L456.189 111.068Z",
    fill: "#514EFF"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M456.691 107.613H455.443V110.78H456.691V107.613Z",
    fill: "#514EFF"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M471.25 110.493L471.371 110.784L471.492 111.065V110.389L471.371 110.445L471.25 110.493Z",
    fill: "#514EFF"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M471.492 107.61H470.751V110.784H471.492V107.61Z",
    fill: "#514EFF"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.528 106.942L234.568 106.974L235.414 107.562L240.915 111.404H471.492V110.156H241.309L241.148 110.043L240.972 109.922L240.964 109.914L238.491 108.191H471.492V106.943H234.528V106.942ZM463.028 108.19H464.413L463.72 107.901L463.028 108.19ZM447.724 108.19H449.11L448.417 107.901L447.724 108.19ZM432.414 108.19H433.8L433.107 107.901L432.414 108.19ZM417.111 108.19H418.497L417.804 107.901L417.111 108.19ZM401.801 108.19H403.187L402.494 107.901L401.801 108.19ZM386.498 108.19H387.884L387.191 107.901L386.498 108.19ZM371.188 108.19H372.573L371.88 107.901L371.188 108.19ZM355.877 108.19H357.263L356.57 107.901L355.877 108.19ZM340.575 108.19H341.96L341.268 107.901L340.575 108.19ZM325.264 108.19H326.65L325.957 107.901L325.264 108.19ZM309.961 108.19H311.347L310.654 107.901L309.961 108.19ZM294.651 108.19H296.036L295.344 107.901L294.651 108.19ZM279.348 108.19H280.734L280.041 107.901L279.348 108.19ZM264.038 108.19H265.424L264.731 107.901L264.038 108.19ZM248.736 108.19H250.121L249.428 107.901L248.736 108.19Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.962 111.068L402.493 107.901L410.026 111.068L410.268 110.492L402.493 107.224L394.72 110.492L394.962 111.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.268 111.068L417.801 107.901L425.333 111.068L425.575 110.492L417.801 107.224L410.026 110.492L410.268 111.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.771 107.613H409.523V110.78H410.771V107.613Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.655 111.068L387.187 107.901L394.719 111.068L394.962 110.492L387.187 107.224L379.413 110.492L379.655 111.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.466 107.613H394.217V110.78H395.466V107.613Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.413 111.068L379.655 110.492L371.88 107.224L364.105 110.492L364.348 111.068L371.88 107.901L379.413 111.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.159 107.613H378.91V110.78H380.159V107.613Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.041 111.068L356.573 107.901L364.105 111.068L364.348 110.492L356.573 107.224L348.799 110.492L349.041 111.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.851 107.613H363.603V110.78H364.851V107.613Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.734 111.068L341.267 107.901L348.799 111.068L349.041 110.492L341.267 107.224L333.492 110.492L333.734 111.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.545 107.613H348.296V110.78H349.545V107.613Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.428 111.068L325.96 107.901L333.493 111.068L333.734 110.492L325.96 107.224L318.186 110.492L318.428 111.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.238 107.613H332.989V110.78H334.238V107.613Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.121 111.068L310.653 107.901L318.185 111.068L318.428 110.492L310.653 107.224L302.879 110.492L303.121 111.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.93 107.613H317.682V110.78H318.93V107.613Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.814 111.068L295.347 107.901L302.879 111.068L303.121 110.492L295.347 107.224L287.572 110.492L287.814 111.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.624 107.613H302.376V110.78H303.624V107.613Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.508 111.068L280.04 107.901L287.573 111.068L287.814 110.492L280.04 107.224L272.266 110.492L272.508 111.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.318 107.613H287.069V110.78H288.318V107.613Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.201 111.068L264.733 107.901L272.265 111.068L272.508 110.492L264.733 107.224L256.959 110.492L257.201 111.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.011 107.613H271.762V110.78H273.011V107.613Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.894 111.068L249.427 107.901L256.959 111.068L257.201 110.492L249.427 107.224L241.652 110.492L241.894 111.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.704 107.613H256.456V110.78H257.704V107.613Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.665 107.298L236.34 107.831L241.602 111.044L241.927 110.512L236.665 107.298Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.398 107.613H241.149V110.78H242.398V107.613Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.574 111.068L433.107 107.901L440.639 111.068L440.882 110.492L433.107 107.224L425.332 110.492L425.574 111.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.078 107.613H424.829V110.78H426.078V107.613Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.882 111.068L448.414 107.901L455.946 111.068L456.188 110.492L448.414 107.224L440.64 110.492L440.882 111.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.386 107.613H440.137V110.78H441.386V107.613Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.189 111.068L463.721 107.901L471.253 111.068L471.495 110.492L463.721 107.224L455.946 110.492L456.189 111.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.691 107.613H455.443V110.78H456.691V107.613Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.25 110.493L471.371 110.784L471.492 111.065V110.389L471.371 110.445L471.25 110.493Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.492 107.61H470.751V110.784H471.492V107.61Z",
    fill: "black"
  }))), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M469.247 129.774H489.782V107.136H469.247L466.089 118.454L469.247 129.774Z",
    fill: "#514EFF"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M466.089 118.456L469.246 129.774H474.484L471.326 118.456L474.484 107.139H469.246L466.089 118.456Z",
    fill: "black"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M469.88 108.378L467.197 117.99H470.444L473.126 108.378H469.88Z",
    fill: "#37474F"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M474.768 108.378L472.086 117.99H481.769V108.378H474.768Z",
    fill: "#37474F"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M470.444 118.944L473.126 128.557H469.88L467.197 118.944H470.444Z",
    fill: "#37474F"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M477.93 108.378L481.766 112.214V109.898L480.246 108.378H477.93Z",
    fill: "#455A64"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M469.02 125.467L469.879 128.561H472.113L469.02 125.467Z",
    fill: "#455A64"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M470.439 118.945H469.417L470.837 120.365L470.439 118.945Z",
    fill: "#455A64"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M467.473 116.999L468.458 117.986H470.44L470.513 117.714L467.979 115.182L467.473 116.999Z",
    fill: "#455A64"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M474.275 110.124L474.112 110.703L481.395 117.986H481.766V117.614L474.275 110.124Z",
    fill: "#455A64"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M471.787 108.378L472.837 109.418L472.999 108.839L472.529 108.378H471.787Z",
    fill: "#455A64"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M472.258 117.353L472.104 117.941L472.149 117.986H472.892L472.258 117.353Z",
    fill: "#455A64"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M468.277 114.114L470.811 116.647L470.973 116.068L468.441 113.535L468.277 114.114Z",
    fill: "#455A64"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M476.962 108.378L481.766 113.182V113.055L477.089 108.378H476.962Z",
    fill: "#455A64"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M472.43 116.755L472.402 116.864L473.524 117.986H473.65L472.43 116.755Z",
    fill: "#455A64"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M468.575 113.046L471.109 115.579L471.145 115.47L468.602 112.938L468.575 113.046Z",
    fill: "#455A64"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M467.201 118.945L467.237 119.08L471.733 123.577L471.679 123.395L467.237 118.945H467.201Z",
    fill: "#455A64"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M489.781 111.582H519.656V107.136H489.781V111.582Z",
    fill: "#514EFF"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M489.781 111.582H519.656V107.136H489.781V111.582Z",
    fill: "black"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M509.771 107.136V103.99C509.771 103.171 510.347 102.506 511.056 102.506H518.059C518.768 102.506 519.344 103.171 519.344 103.99V107.136",
    stroke: "#514EFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M519.344 104.461H509.771",
    stroke: "#514EFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M519.344 106.004H509.771",
    stroke: "#514EFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M499.934 107.136V103.99C499.934 103.171 500.509 102.506 501.218 102.506H508.221C508.93 102.506 509.506 103.171 509.506 103.99V107.136",
    stroke: "#514EFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M509.506 104.461H499.934",
    stroke: "#514EFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M509.506 106.004H499.934",
    stroke: "#514EFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M490.095 107.136V103.99C490.095 103.171 490.67 102.506 491.38 102.506H498.382C499.092 102.506 499.667 103.171 499.667 103.99V107.136",
    stroke: "#514EFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M499.667 104.461H490.095",
    stroke: "#514EFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M499.667 106.004H490.095",
    stroke: "#514EFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M370.523 116.659H374.021V107.406H370.523V116.659Z",
    fill: "#514EFF"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M359.656 116.659H363.153V107.406H359.656V116.659Z",
    fill: "#514EFF"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M359.656 116.659H374.021V113.047H359.656V116.659Z",
    fill: "#514EFF"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.523 116.659H374.021V107.406H370.523V116.659Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.656 116.659H363.153V107.406H359.656V116.659Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.656 116.659H374.021V113.047H359.656V116.659Z",
    fill: "black"
  }))), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M361.244 118.037H372.432V116.659H361.244V118.037Z",
    fill: "#514EFF"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M370.542 118.019V133.047",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M363.171 118.019V133.047",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M364.991 135.158V135.61L366.502 136.569H367.569L369.071 135.61V135.158H364.991Z",
    fill: "#514EFF"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M362.363 133.881L363.782 135.159H370.288L371.707 133.881V131.944H362.363V133.881Z",
    fill: "#514EFF"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M363.782 135.159H370.288L371.707 133.881H362.363L363.782 135.159Z",
    fill: "black"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M367.435 136.569C367.424 136.836 367.362 138.278 367.353 138.507C366.725 138.393 366.058 138.666 365.852 139.361C365.22 141.145 367.425 142.257 368.538 140.805C368.711 140.537 368.79 140.21 368.805 139.885C368.985 141.417 366.997 142.265 365.892 141.242C364.749 140.177 365.334 137.87 367.035 137.822L366.702 138.155L366.635 136.569H367.435Z",
    fill: "#514EFF"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M395.087 171.577C387.172 163.295 374.827 150.149 366.885 141.709L367.187 141.696L350.278 163.06C346.084 168.386 337.558 179.093 333.315 184.383C342.597 172.352 357.406 153.56 366.874 141.449L367.018 141.266L367.176 141.437C375.072 149.98 387.343 163.069 395.087 171.577Z",
    fill: "#263238"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M476.061 30.7072C476.061 32.4104 477.441 33.7904 479.144 33.7904C480.847 33.7904 482.227 32.4096 482.227 30.7072C482.227 29.004 480.846 27.624 479.144 27.624C477.441 27.624 476.061 29.004 476.061 30.7072Z",
    fill: "#263238"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M479.145 31.9352C479.823 31.9352 480.373 31.3855 480.373 30.7072C480.373 30.029 479.823 29.4792 479.145 29.4792C478.467 29.4792 477.917 30.029 477.917 30.7072C477.917 31.3855 478.467 31.9352 479.145 31.9352Z",
    fill: "#455A64"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M518.028 110.78C518.028 112.483 519.409 113.864 521.112 113.864C522.815 113.864 524.195 112.483 524.195 110.78C524.195 109.077 522.814 107.697 521.112 107.697C519.408 107.697 518.028 109.077 518.028 110.78Z",
    fill: "#263238"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M521.112 112.008C521.79 112.008 522.34 111.458 522.34 110.78C522.34 110.102 521.79 109.552 521.112 109.552C520.434 109.552 519.884 110.102 519.884 110.78C519.884 111.458 520.434 112.008 521.112 112.008Z",
    fill: "#455A64"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M283.752 98.8467H287.011V94.3843H283.752V98.8467Z",
    fill: "#514EFF"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M283.226 98.5896C283.226 99.78 284.191 100.746 285.382 100.746C286.572 100.746 287.538 99.78 287.538 98.5896C287.538 97.3992 286.572 96.4336 285.382 96.4336C284.191 96.4336 283.226 97.3984 283.226 98.5896Z",
    fill: "#263238"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M285.383 99.4489C285.857 99.4489 286.242 99.0642 286.242 98.5897C286.242 98.1151 285.857 97.7305 285.383 97.7305C284.908 97.7305 284.523 98.1151 284.523 98.5897C284.523 99.0642 284.908 99.4489 285.383 99.4489Z",
    fill: "#455A64"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M519.481 218.193H522.74V213.73H519.481V218.193Z",
    fill: "#514EFF"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M518.955 217.935C518.955 219.126 519.92 220.091 521.111 220.091C522.302 220.091 523.267 219.126 523.267 217.935C523.267 216.745 522.301 215.779 521.111 215.779C519.921 215.779 518.955 216.745 518.955 217.935Z",
    fill: "#263238"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M521.111 218.795C521.586 218.795 521.97 218.41 521.97 217.935C521.97 217.461 521.586 217.076 521.111 217.076C520.637 217.076 520.252 217.461 520.252 217.935C520.252 218.41 520.637 218.795 521.111 218.795Z",
    fill: "#455A64"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M518.955 312.032C518.955 313.222 519.92 314.188 521.111 314.188C522.302 314.188 523.267 313.222 523.267 312.032C523.267 310.842 522.301 309.876 521.111 309.876C519.921 309.876 518.955 310.841 518.955 312.032Z",
    fill: "#263238"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M521.111 312.891C521.586 312.891 521.97 312.507 521.97 312.032C521.97 311.558 521.586 311.173 521.111 311.173C520.637 311.173 520.252 311.558 520.252 312.032C520.252 312.507 520.637 312.891 521.111 312.891Z",
    fill: "#455A64"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M478.675 352.952H479.615C481.598 352.952 483.206 354.56 483.206 356.543V361.075H475.084V356.543C475.083 354.559 476.691 352.952 478.675 352.952Z",
    fill: "#514EFF"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M479.145 357.59C479.713 357.59 480.173 357.129 480.173 356.562C480.173 355.994 479.713 355.534 479.145 355.534C478.577 355.534 478.117 355.994 478.117 356.562C478.117 357.129 478.577 357.59 479.145 357.59Z",
    fill: "#263238"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M510.295 342.943H536.076V339.488H510.295V342.943Z",
    fill: "#455A64"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M510.296 339.488H506.146V342.942H510.296V339.488Z",
    fill: "#37474F"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M510.295 339.489H536.076V336.034H510.295V339.489Z",
    fill: "#455A64"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M510.296 336.034H506.146V339.488H510.296V336.034Z",
    fill: "#37474F"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M536.077 339.488C526.1 339.612 516.122 339.613 506.146 339.488C516.122 339.363 526.1 339.364 536.077 339.488Z",
    fill: "#263238"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M510.295 336.034H536.076V332.58H510.295V336.034Z",
    fill: "#455A64"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M510.296 332.579H506.146V336.034H510.296V332.579Z",
    fill: "#37474F"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M536.077 336.034C526.1 336.158 516.122 336.159 506.146 336.034C516.122 335.909 526.1 335.91 536.077 336.034Z",
    fill: "#263238"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M510.295 332.58H536.076V329.125H510.295V332.58Z",
    fill: "#455A64"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M510.296 329.125H506.146V332.579H510.296V329.125Z",
    fill: "#37474F"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M536.077 332.579C526.1 332.703 516.122 332.704 506.146 332.579C516.122 332.455 526.1 332.455 536.077 332.579Z",
    fill: "#263238"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M510.295 329.125H536.076V325.671H510.295V329.125Z",
    fill: "#455A64"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M510.296 325.67H506.146V329.125H510.296V325.67Z",
    fill: "#37474F"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M536.077 329.125C526.1 329.249 516.122 329.25 506.146 329.125C516.122 329 526.1 329.001 536.077 329.125Z",
    fill: "#263238"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M510.295 325.671H536.076V322.217H510.295V325.671Z",
    fill: "#455A64"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M510.296 322.216H506.146V325.67H510.296V322.216Z",
    fill: "#37474F"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M536.077 325.67C526.1 325.794 516.122 325.795 506.146 325.67C516.122 325.546 526.1 325.546 536.077 325.67Z",
    fill: "#263238"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M520.547 322.216H521.674V314.156H520.547V322.216Z",
    fill: "#514EFF"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M328.606 375.313H295.781C292.865 375.313 290.082 373.326 289.021 369.958H321.845C322.907 373.326 325.689 375.313 328.606 375.313Z",
    fill: "#514EFF"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M321.845 369.958H289.02L282.528 350.062H315.353L321.845 369.958Z",
    fill: "#514EFF"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.606 375.313H295.781C292.865 375.313 290.082 373.326 289.021 369.958H321.845C322.907 373.326 325.689 375.313 328.606 375.313Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.845 369.958H289.02L282.528 350.062H315.353L321.845 369.958Z",
    fill: "black"
  }))), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M299.183 268.347H266.358C266.462 268.342 266.566 268.339 266.669 268.339H299.494C299.391 268.339 299.287 268.343 299.183 268.347Z",
    fill: "#514EFF"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M309.923 333.23H277.098L266.359 300.327H299.183L309.923 333.23Z",
    fill: "#514EFF"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.923 333.23H277.098L266.359 300.327H299.183L309.923 333.23Z",
    fill: "black"
  }))), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M335.501 363.835C336.825 368.274 334.97 373.171 331.126 374.855C330.46 375.158 329.533 375.312 328.606 375.312C325.689 375.312 322.907 373.326 321.845 369.958L315.353 350.061H283.149L276.657 369.958C275.468 373.326 272.679 375.312 269.768 375.312C268.841 375.312 268.041 375.157 267.248 374.855C263.404 373.171 261.549 368.274 262.873 363.835L292.161 273.702C293.316 270.449 296.077 268.339 298.887 268.339C298.986 268.339 299.084 268.342 299.184 268.347C299.288 268.342 299.391 268.339 299.494 268.339C302.422 268.339 305.057 270.448 306.212 273.702L335.501 363.835ZM288.452 333.23H309.924L299.184 300.327L288.452 333.23Z",
    fill: "#514EFF"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M292.161 273.702H259.336C260.491 270.45 263.252 268.34 266.062 268.34H298.886C296.077 268.339 293.316 270.449 292.161 273.702Z",
    fill: "#514EFF"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M269.768 375.313H236.943C236.016 375.313 235.216 375.158 234.423 374.855H267.248C268.04 375.158 268.84 375.313 269.768 375.313Z",
    fill: "#514EFF"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M262.873 363.835H230.048L259.336 273.703H292.161L262.873 363.835Z",
    fill: "#514EFF"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M267.248 374.855H234.423C230.579 373.171 228.724 368.274 230.048 363.835H262.873C261.549 368.275 263.404 373.171 267.248 374.855Z",
    fill: "#514EFF"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.161 273.702H259.336C260.491 270.45 263.252 268.34 266.062 268.34H298.886C296.077 268.339 293.316 270.449 292.161 273.702Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.768 375.313H236.943C236.016 375.313 235.216 375.158 234.423 374.855H267.248C268.04 375.158 268.84 375.313 269.768 375.313Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.873 363.835H230.048L259.336 273.703H292.161L262.873 363.835Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.248 374.855H234.423C230.579 373.171 228.724 368.274 230.048 363.835H262.873C261.549 368.275 263.404 373.171 267.248 374.855Z",
    fill: "black"
  }))), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M299.494 280.654C300.359 280.654 301.059 279.595 301.059 278.289C301.059 276.983 300.359 275.924 299.494 275.924C298.63 275.924 297.93 276.983 297.93 278.289C297.93 279.595 298.63 280.654 299.494 280.654Z",
    fill: "#EBEBEB"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M300.918 279.248C300.853 279.486 300.762 279.699 300.639 279.888L298.07 277.328C298.136 277.09 298.226 276.877 298.35 276.688L300.918 279.248Z",
    fill: "#C7C7C7"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M272.172 366.409C272.172 367.715 271.471 368.774 270.607 368.774C269.743 368.774 269.042 367.715 269.042 366.409C269.042 365.103 269.743 364.044 270.607 364.044C271.471 364.044 272.172 365.103 272.172 366.409Z",
    fill: "#EBEBEB"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M272.032 367.369C271.966 367.607 271.876 367.82 271.752 368.009L269.184 365.449C269.249 365.211 269.34 364.998 269.463 364.809L272.032 367.369Z",
    fill: "#C7C7C7"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M330.89 366.409C330.89 367.715 330.19 368.774 329.326 368.774C328.462 368.774 327.761 367.715 327.761 366.409C327.761 365.103 328.461 364.044 329.326 364.044C330.19 364.044 330.89 365.103 330.89 366.409Z",
    fill: "#EBEBEB"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M330.75 367.369C330.685 367.607 330.594 367.82 330.471 368.009L327.902 365.449C327.968 365.211 328.058 364.998 328.182 364.809L330.75 367.369Z",
    fill: "#C7C7C7"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M208.322 316.775H175.497C183.051 316.775 189.147 309.736 189.147 301.169C189.147 292.291 183.051 285.253 175.497 285.253H208.322C215.875 285.253 221.971 292.291 221.971 301.169C221.971 309.736 215.876 316.775 208.322 316.775Z",
    fill: "#514EFF"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.322 316.775H175.497C183.051 316.775 189.147 309.736 189.147 301.169C189.147 292.291 183.051 285.253 175.497 285.253H208.322C215.875 285.253 221.971 292.291 221.971 301.169C221.971 309.736 215.876 316.775 208.322 316.775Z",
    fill: "black"
  }))), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M232.972 373.858H200.147C198.689 373.858 196.7 373.547 194.845 372.174H227.67C229.525 373.547 231.514 373.858 232.972 373.858Z",
    fill: "#514EFF"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M227.67 372.174H194.845C193.118 370.947 191.66 368.961 190.604 366.819H223.429C224.485 368.961 225.944 370.948 227.67 372.174Z",
    fill: "#514EFF"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M223.429 366.819H190.605C188.749 362.381 187.822 356.871 187.822 348.451H220.647C220.647 356.871 221.574 362.38 223.429 366.819Z",
    fill: "#514EFF"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M220.647 348.451H187.822C187.688 345.549 187.157 343.555 186.229 341.871H219.054C219.981 343.555 220.513 345.549 220.647 348.451Z",
    fill: "#514EFF"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M219.054 341.871H186.23C185.436 340.187 183.844 338.658 182.251 337.431C179.469 335.29 176.028 334.071 174.832 333.761H207.657C208.853 334.071 212.294 335.29 215.076 337.431C216.669 338.659 218.262 340.187 219.054 341.871Z",
    fill: "#514EFF"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.972 373.858H200.147C198.689 373.858 196.7 373.547 194.845 372.174H227.67C229.525 373.547 231.514 373.858 232.972 373.858Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.67 372.174H194.845C193.118 370.947 191.66 368.961 190.604 366.819H223.429C224.485 368.961 225.944 370.948 227.67 372.174Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.429 366.819H190.605C188.749 362.381 187.822 356.871 187.822 348.451H220.647C220.647 356.871 221.574 362.38 223.429 366.819Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.647 348.451H187.822C187.688 345.549 187.157 343.555 186.229 341.871H219.054C219.981 343.555 220.513 345.549 220.647 348.451Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.054 341.871H186.23C185.436 340.187 183.844 338.658 182.251 337.431C179.469 335.29 176.028 334.071 174.832 333.761H207.657C208.853 334.071 212.294 335.29 215.076 337.431C216.669 338.659 218.262 340.187 219.054 341.871Z",
    fill: "black"
  }))), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M184.598 375.386H151.774C147.667 375.386 144.482 371.561 144.482 366.967H177.307C177.307 371.561 180.492 375.386 184.598 375.386Z",
    fill: "#514EFF"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M177.307 276.686H144.482V366.967H177.307V276.686Z",
    fill: "#514EFF"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M177.307 276.686H144.482C144.482 271.937 147.668 268.267 151.774 268.267H184.598C180.492 268.267 177.307 271.937 177.307 276.686Z",
    fill: "#514EFF"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.598 375.386H151.774C147.667 375.386 144.482 371.561 144.482 366.967H177.307C177.307 371.561 180.492 375.386 184.598 375.386Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.307 276.686H144.482V366.967H177.307V276.686Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.307 276.686H144.482C144.482 271.937 147.668 268.267 151.774 268.267H184.598C180.492 268.267 177.307 271.937 177.307 276.686Z",
    fill: "black"
  }))), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M240.527 362.683C241.851 367.122 239.728 371.863 235.883 373.4C235.352 373.548 234.296 373.858 232.972 373.858C231.514 373.858 229.525 373.547 227.67 372.174C225.943 370.947 224.484 368.961 223.429 366.819C221.574 362.381 220.647 356.871 220.647 348.451C220.512 345.549 219.981 343.555 219.054 341.871C218.261 340.187 216.668 338.658 215.076 337.431C212.293 335.29 208.852 334.071 207.656 333.761H192.018V366.967C192.018 371.56 188.705 375.386 184.599 375.386C180.492 375.386 177.308 371.56 177.308 366.967V276.686C177.308 271.937 180.492 268.267 184.599 268.267H208.322C224.088 268.267 236.682 282.956 236.682 301.169C236.682 311.265 232.704 320.143 226.346 326.265C228.067 327.794 229.66 329.633 230.984 331.93C233.632 336.361 235.352 342.026 235.352 348.451C235.224 353.045 235.621 355.955 235.883 357.484C238.007 358.245 239.727 360.083 240.527 362.683ZM208.322 316.775C215.876 316.775 221.972 309.736 221.972 301.169C221.972 292.291 215.876 285.253 208.322 285.253H192.019V316.775H208.322Z",
    fill: "#514EFF"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M186.608 278.289C186.608 279.596 185.907 280.654 185.043 280.654C184.179 280.654 183.479 279.595 183.479 278.289C183.479 276.983 184.179 275.924 185.043 275.924C185.907 275.924 186.608 276.983 186.608 278.289Z",
    fill: "#EBEBEB"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M186.468 279.248C186.403 279.486 186.312 279.699 186.189 279.888L183.62 277.328C183.686 277.091 183.776 276.877 183.899 276.688L186.468 279.248Z",
    fill: "#C7C7C7"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M186.608 366.409C186.608 367.715 185.907 368.774 185.043 368.774C184.179 368.774 183.479 367.715 183.479 366.409C183.479 365.103 184.179 364.044 185.043 364.044C185.907 364.044 186.608 365.103 186.608 366.409Z",
    fill: "#EBEBEB"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M186.468 367.369C186.403 367.607 186.312 367.82 186.189 368.009L183.62 365.449C183.686 365.211 183.776 364.998 183.899 364.809L186.468 367.369Z",
    fill: "#C7C7C7"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M233.694 368.774C234.558 368.774 235.258 367.715 235.258 366.409C235.258 365.103 234.558 364.044 233.694 364.044C232.829 364.044 232.129 365.103 232.129 366.409C232.129 367.715 232.829 368.774 233.694 368.774Z",
    fill: "#EBEBEB"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M235.119 367.369C235.053 367.607 234.963 367.82 234.839 368.009L232.271 365.449C232.336 365.211 232.427 364.998 232.55 364.809L235.119 367.369Z",
    fill: "#C7C7C7"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M231.188 300.327C231.188 301.634 230.487 302.692 229.623 302.692C228.759 302.692 228.059 301.634 228.059 300.327C228.059 299.021 228.759 297.963 229.623 297.963C230.487 297.962 231.188 299.021 231.188 300.327Z",
    fill: "#EBEBEB"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M231.048 301.287C230.983 301.524 230.892 301.738 230.769 301.927L228.2 299.367C228.266 299.129 228.356 298.915 228.479 298.727L231.048 301.287Z",
    fill: "#C7C7C7"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M499.673 358.399H466.849C484.342 358.244 498.388 342.026 498.388 321.671C498.388 301.627 484.342 285.253 466.849 285.253H499.673C517.167 285.253 531.213 301.627 531.213 321.671C531.213 342.026 517.167 358.245 499.673 358.399Z",
    fill: "#514EFF"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M499.673 358.399H466.849C484.342 358.244 498.388 342.026 498.388 321.671C498.388 301.627 484.342 285.253 466.849 285.253H499.673C517.167 285.253 531.213 301.627 531.213 321.671C531.213 342.026 517.167 358.245 499.673 358.399Z",
    fill: "black"
  }))), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M499.674 268.266C525.252 268.266 545.924 292.292 545.924 321.671C545.924 351.361 525.252 375.386 499.674 375.386H484.035C479.929 375.386 476.744 371.561 476.744 366.967V276.686C476.744 271.937 479.93 268.266 484.035 268.266H499.674V268.266ZM499.674 358.399C517.167 358.244 531.213 342.026 531.213 321.671C531.213 301.627 517.167 285.253 499.674 285.253H491.455V358.399H499.674Z",
    fill: "#514EFF"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M484.035 375.386H451.21C447.104 375.386 443.919 371.561 443.919 366.966H476.744C476.744 371.561 479.929 375.386 484.035 375.386Z",
    fill: "#514EFF"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M476.744 276.686H443.919V366.966H476.744V276.686Z",
    fill: "#514EFF"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M476.744 276.686H443.919C443.919 271.937 447.105 268.266 451.21 268.266H484.035C479.929 268.266 476.744 271.937 476.744 276.686Z",
    fill: "#514EFF"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M484.035 375.386H451.21C447.104 375.386 443.919 371.561 443.919 366.966H476.744C476.744 371.561 479.929 375.386 484.035 375.386Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.744 276.686H443.919V366.966H476.744V276.686Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.744 276.686H443.919C443.919 271.937 447.105 268.266 451.21 268.266H484.035C479.929 268.266 476.744 271.937 476.744 276.686Z",
    fill: "black"
  }))), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M487.182 278.289C487.182 279.595 486.482 280.654 485.618 280.654C484.754 280.654 484.053 279.594 484.053 278.289C484.053 276.982 484.754 275.924 485.618 275.924C486.482 275.924 487.182 276.982 487.182 278.289Z",
    fill: "#EBEBEB"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M487.042 279.248C486.977 279.486 486.886 279.699 486.763 279.888L484.194 277.328C484.26 277.09 484.35 276.877 484.474 276.688L487.042 279.248Z",
    fill: "#C7C7C7"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M540.493 321.826C540.493 323.133 539.792 324.191 538.928 324.191C538.064 324.191 537.363 323.132 537.363 321.826C537.363 320.52 538.064 319.462 538.928 319.462C539.793 319.462 540.493 320.52 540.493 321.826Z",
    fill: "#EBEBEB"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M540.354 322.786C540.288 323.023 540.198 323.237 540.075 323.426L537.506 320.866C537.571 320.628 537.662 320.414 537.785 320.226L540.354 322.786Z",
    fill: "#C7C7C7"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M487.182 366.409C487.182 367.715 486.482 368.774 485.618 368.774C484.754 368.774 484.053 367.715 484.053 366.409C484.053 365.102 484.754 364.044 485.618 364.044C486.482 364.044 487.182 365.103 487.182 366.409Z",
    fill: "#EBEBEB"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M487.042 367.369C486.977 367.607 486.886 367.82 486.763 368.009L484.194 365.449C484.26 365.211 484.35 364.998 484.474 364.809L487.042 367.369Z",
    fill: "#C7C7C7"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M114.01 309.736H81.1855C87.0191 309.736 91.6559 304.079 91.6559 297.343C91.6559 290.608 87.0183 285.253 81.1855 285.253H114.01C119.844 285.253 124.481 290.607 124.481 297.343C124.481 304.079 119.843 309.736 114.01 309.736Z",
    fill: "#514EFF"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.01 309.736H81.1855C87.0191 309.736 91.6559 304.079 91.6559 297.343C91.6559 290.608 87.0183 285.253 81.1855 285.253H114.01C119.844 285.253 124.481 290.607 124.481 297.343C124.481 304.079 119.843 309.736 114.01 309.736Z",
    fill: "black"
  }))), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M119.178 358.399H86.3535C93.9071 358.244 100.003 351.361 100.003 342.483C100.003 333.761 93.9079 326.878 86.3535 326.723H119.178C126.732 326.878 132.828 333.761 132.828 342.483C132.827 351.361 126.732 358.245 119.178 358.399Z",
    fill: "#514EFF"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.178 358.399H86.3535C93.9071 358.244 100.003 351.361 100.003 342.483C100.003 333.761 93.9079 326.878 86.3535 326.723H119.178C126.732 326.878 132.828 333.761 132.828 342.483C132.827 351.361 126.732 358.245 119.178 358.399Z",
    fill: "black"
  }))), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M134.152 314.788C142.109 320.601 147.539 330.859 147.539 342.484C147.539 360.697 134.818 375.387 119.179 375.387H95.7247C95.3279 375.231 95.3279 375.387 95.1943 375.387C91.2159 375.387 87.9023 371.561 87.9023 366.967V276.686C87.9023 271.937 91.2159 268.267 95.1943 268.267C95.3287 268.267 95.3287 268.267 95.5911 268.267H114.012C127.93 268.267 139.194 281.272 139.194 297.343C139.193 303.924 137.338 309.891 134.152 314.788ZM119.179 358.399C126.733 358.244 132.829 351.361 132.829 342.483C132.829 333.761 126.734 326.878 119.179 326.723H102.613V358.399H119.179ZM102.613 285.253V309.736H114.01C119.844 309.736 124.481 304.079 124.481 297.343C124.481 290.608 119.843 285.253 114.01 285.253H102.613Z",
    fill: "#514EFF"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6152 375.318H95.44C95.504 375.318 95.592 375.335 95.724 375.387H62.8992C62.7672 375.335 62.6792 375.318 62.6152 375.318Z",
    fill: "#514EFF"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1931 375.386H62.3683C58.3899 375.386 55.0771 371.561 55.0771 366.967H87.9019C87.9019 371.561 91.2147 375.386 95.1931 375.386Z",
    fill: "#514EFF"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9019 276.686H55.0771V366.967H87.9019V276.686Z",
    fill: "#514EFF"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9019 276.686H55.0771C55.0771 271.937 58.3899 268.267 62.3683 268.267H95.1931C91.2147 268.267 87.9019 271.937 87.9019 276.686Z",
    fill: "#514EFF"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.6152 375.318H95.44C95.504 375.318 95.592 375.335 95.724 375.387H62.8992C62.7672 375.335 62.6792 375.318 62.6152 375.318Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1931 375.386H62.3683C58.3899 375.386 55.0771 371.561 55.0771 366.967H87.9019C87.9019 371.561 91.2147 375.386 95.1931 375.386Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9019 276.686H55.0771V366.967H87.9019V276.686Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9019 276.686H55.0771C55.0771 271.937 58.3899 268.267 62.3683 268.267H95.1931C91.2147 268.267 87.9019 271.937 87.9019 276.686Z",
    fill: "black"
  }))), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7575 278.289C96.7575 279.596 96.0567 280.654 95.1927 280.654C94.3287 280.654 93.6279 279.595 93.6279 278.289C93.6279 276.984 94.3287 275.924 95.1927 275.924C96.0567 275.924 96.7575 276.984 96.7575 278.289Z",
    fill: "#EBEBEB"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6175 279.249C96.5519 279.487 96.4615 279.7 96.3383 279.889L93.7695 277.329C93.8351 277.092 93.9255 276.878 94.0487 276.689L96.6175 279.249Z",
    fill: "#C7C7C7"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7575 366.41C96.7575 367.716 96.0567 368.775 95.1927 368.775C94.3287 368.775 93.6279 367.715 93.6279 366.41C93.6279 365.103 94.3287 364.045 95.1927 364.045C96.0567 364.045 96.7575 365.103 96.7575 366.41Z",
    fill: "#EBEBEB"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6175 367.369C96.5519 367.607 96.4615 367.82 96.3383 368.009L93.7695 365.449C93.8351 365.211 93.9255 364.998 94.0487 364.809L96.6175 367.369Z",
    fill: "#C7C7C7"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M142.06 345.155C142.06 346.461 141.359 347.519 140.495 347.519C139.631 347.519 138.931 346.46 138.931 345.155C138.931 343.848 139.631 342.79 140.495 342.79C141.359 342.79 142.06 343.849 142.06 345.155Z",
    fill: "#EBEBEB"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M141.92 346.115C141.855 346.353 141.764 346.566 141.641 346.755L139.072 344.195C139.138 343.957 139.228 343.743 139.351 343.555L141.92 346.115Z",
    fill: "#C7C7C7"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M131.74 296.887C132.604 296.887 133.304 295.828 133.304 294.522C133.304 293.216 132.604 292.157 131.74 292.157C130.875 292.157 130.175 293.216 130.175 294.522C130.175 295.828 130.875 296.887 131.74 296.887Z",
    fill: "#EBEBEB"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M133.164 295.481C133.099 295.719 133.008 295.932 132.885 296.121L130.316 293.561C130.382 293.322 130.472 293.11 130.596 292.921L133.164 295.481Z",
    fill: "#C7C7C7"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M410.399 238.36L385.655 240.931L373.607 178.486L398.352 175.915L410.399 238.36Z",
    fill: "#514EFF"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M380.31 168.619L405.055 166.047C404.817 166.072 404.579 166.109 404.341 166.159C400.134 167.037 397.507 171.523 398.352 175.915L373.607 178.486C372.761 174.095 375.389 169.608 379.596 168.73C379.834 168.68 380.072 168.643 380.31 168.619Z",
    fill: "#514EFF"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.399 238.36L385.655 240.931L373.607 178.486L398.352 175.915L410.399 238.36Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31 168.619L405.055 166.047C404.817 166.072 404.579 166.109 404.341 166.159C400.134 167.037 397.507 171.523 398.352 175.915L373.607 178.486C372.761 174.095 375.389 169.608 379.596 168.73C379.834 168.68 380.072 168.643 380.31 168.619Z",
    fill: "black"
  }))), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M423.853 270.835L399.108 273.406C397.997 273.521 396.879 273.347 395.835 272.939C394.969 272.6 394.153 272.101 393.433 271.474L418.177 268.903C418.897 269.53 419.713 270.029 420.58 270.367C421.624 270.775 422.741 270.951 423.853 270.835Z",
    fill: "#514EFF"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M418.178 268.902L393.433 271.474C393.098 271.226 392.757 270.975 392.554 270.701L417.299 268.13C417.502 268.404 417.843 268.654 418.178 268.902Z",
    fill: "#514EFF"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M417.299 268.13L392.555 270.701L334.767 212.731L359.511 210.161L417.299 268.13Z",
    fill: "#514EFF"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.853 270.835L399.108 273.406C397.997 273.521 396.879 273.347 395.835 272.939C394.969 272.6 394.153 272.101 393.433 271.474L418.177 268.903C418.897 269.53 419.713 270.029 420.58 270.367C421.624 270.775 422.741 270.951 423.853 270.835Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.178 268.902L393.433 271.474C393.098 271.226 392.757 270.975 392.554 270.701L417.299 268.13C417.502 268.404 417.843 268.654 418.178 268.902Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.299 268.13L392.555 270.701L334.767 212.731L359.511 210.161L417.299 268.13Z",
    fill: "black"
  }))), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M364.931 283.082L340.187 285.653C338.989 285.777 337.824 285.603 336.755 285.186C334.211 284.192 332.215 281.818 331.63 278.803L356.375 276.232C356.96 279.246 358.956 281.621 361.5 282.614C362.568 283.032 363.734 283.206 364.931 283.082Z",
    fill: "#514EFF"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M321.355 180.398L346.1 177.827C344.275 178.017 342.49 178.887 341.104 180.409L316.359 182.98C317.744 181.458 319.531 180.588 321.355 180.398Z",
    fill: "#514EFF"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M356.375 276.232L331.63 278.802L314.652 190.746L339.397 188.175L356.375 276.232Z",
    fill: "#514EFF"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M339.397 188.175L314.652 190.746C313.98 188.047 314.578 185.087 316.358 182.979L341.103 180.408C339.324 182.517 338.725 185.477 339.397 188.175Z",
    fill: "#514EFF"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.931 283.082L340.187 285.653C338.989 285.777 337.824 285.603 336.755 285.186C334.211 284.192 332.215 281.818 331.63 278.803L356.375 276.232C356.96 279.246 358.956 281.621 361.5 282.614C362.568 283.032 363.734 283.206 364.931 283.082Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.355 180.398L346.1 177.827C344.275 178.017 342.49 178.887 341.104 180.409L316.359 182.98C317.744 181.458 319.531 180.588 321.355 180.398Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.375 276.232L331.63 278.802L314.652 190.746L339.397 188.175L356.375 276.232Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.397 188.175L314.652 190.746C313.98 188.047 314.578 185.087 316.358 182.979L341.103 180.408C339.324 182.517 338.725 185.477 339.397 188.175Z",
    fill: "black"
  }))), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M408.486 166.526C411.017 167.514 413.056 169.838 413.616 172.742L430.599 260.801C431.476 265.345 428.708 269.862 424.503 270.734C423.181 271.01 421.828 270.855 420.58 270.367C419.714 270.029 418.898 269.53 418.178 268.902C417.843 268.654 417.502 268.404 417.299 268.13L359.511 210.161L371.637 273.059C372.514 277.603 369.746 282.12 365.688 282.963C364.226 283.268 362.792 283.119 361.5 282.614C358.956 281.621 356.96 279.246 356.375 276.232L339.397 188.176C338.725 185.477 339.324 182.517 341.104 180.409C343.358 177.934 346.673 177.181 349.49 178.282C350.435 178.651 351.324 179.228 352.097 180.019L410.398 238.361L398.352 175.915C397.505 171.524 400.132 167.038 404.34 166.159C405.763 165.862 407.189 166.019 408.486 166.526Z",
    fill: "#514EFF"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M366.495 274.821C366.495 276.127 365.794 277.186 364.93 277.186C364.066 277.186 363.365 276.126 363.365 274.821C363.365 273.514 364.066 272.456 364.93 272.456C365.795 272.455 366.495 273.514 366.495 274.821Z",
    fill: "#EBEBEB"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M366.356 275.78C366.29 276.018 366.2 276.231 366.077 276.42L363.508 273.86C363.573 273.622 363.664 273.409 363.787 273.22L366.356 275.78Z",
    fill: "#C7C7C7"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M349.844 189.031C349.844 190.338 349.144 191.396 348.28 191.396C347.416 191.396 346.715 190.337 346.715 189.031C346.715 187.725 347.416 186.667 348.28 186.667C349.144 186.667 349.844 187.726 349.844 189.031Z",
    fill: "#EBEBEB"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M349.704 189.991C349.639 190.23 349.548 190.443 349.425 190.631L346.856 188.071C346.922 187.834 347.012 187.62 347.136 187.431L349.704 189.991Z",
    fill: "#C7C7C7"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M406.93 178.279C407.794 178.279 408.495 177.22 408.495 175.914C408.495 174.608 407.794 173.55 406.93 173.55C406.066 173.55 405.365 174.608 405.365 175.914C405.365 177.22 406.066 178.279 406.93 178.279Z",
    fill: "#EBEBEB"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M408.355 176.874C408.289 177.113 408.199 177.326 408.076 177.514L405.507 174.954C405.572 174.716 405.663 174.503 405.786 174.314L408.355 176.874Z",
    fill: "#C7C7C7"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M425.418 262.613C425.418 263.919 424.717 264.978 423.853 264.978C422.989 264.978 422.288 263.918 422.288 262.613C422.288 261.307 422.989 260.248 423.853 260.248C424.718 260.248 425.418 261.307 425.418 262.613Z",
    fill: "#EBEBEB"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M425.278 263.573C425.212 263.811 425.122 264.024 424.998 264.213L422.43 261.653C422.495 261.415 422.586 261.202 422.709 261.013L425.278 263.573Z",
    fill: "#C7C7C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoBrand);
export default __webpack_public_path__ + "static/media/noBrand.d96be315eba9ba620053051815cd87b7.svg";
export { ForwardRef as ReactComponent };